var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagsBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 618,
    height: 223,
    viewBox: "0 0 618 223",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 617,
    height: 223,
    transform: "translate(0.246094)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1593_3270)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2562,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.432,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.597,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.762,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.091,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.422,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.581,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.759,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.254,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.407,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.584,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.737,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.914,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.071,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.401,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.573,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.233,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.404,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.735,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.553,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.733,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.062,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.207,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.55,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.736,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.887,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.053,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.211,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.548,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.885,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 1.52764,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 10.6937,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 19.8607,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 29.0257,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 38.1922,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 38.1917,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 47.3567,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 56.5247,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 65.6898,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 74.8548,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 74.8538,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 84.0218,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 93.1878,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 93.1873,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 102.353,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 102.354,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 111.519,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 120.685,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7679,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 129.851,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 139.017,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 148.183,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 157.35,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 166.513,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 166.514,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 175.68,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 175.679,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 184.846,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip22_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 194.011,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip23_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 203.178,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip24_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 212.344,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25_1593_3270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.7689,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.9261,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.098,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.2571,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.429,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5872,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.7649,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.9173,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.095,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.254,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.433,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.598,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.763,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.913,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.092,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.251,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.423,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.582,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.76,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.918,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.083,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.255,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.408,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.585,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.738,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.915,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.067,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.244,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.404,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.576,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.742,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.919,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.072,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.236,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.402,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.574,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.732,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.897,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.069,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.234,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.405,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.564,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.736,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.894,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.066,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.231,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.396,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.554,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.734,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 468.891,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.063,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.208,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496.4,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.551,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.737,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.888,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.054,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.212,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.398,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560.549,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.72,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.886,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.043,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.223,
    cy: 221.508,
    r: 1.52764,
    fill: "#1B91FF",
    fillOpacity: 0.08
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1593_3270)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip26_1593_3270)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.2461,
    y: 19.5,
    width: 483,
    height: 184,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip27_1593_3270)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 184,
    transform: "translate(67.2461 19.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1603-inside-1_1593_3270",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2461 19.5H116.246V59.5H67.2461V19.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.2461 19.5H116.246V59.5H67.2461V19.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.246 58.5H67.2461V60.5H116.246V58.5Z",
    fill: "#EFEFF0",
    mask: "url(#path-1603-inside-1_1593_3270)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1605-inside-2_1593_3270",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2461 59.5H116.246V107.5H67.2461V59.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.2461 59.5H116.246V107.5H67.2461V59.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.246 106.5H67.2461V108.5H116.246V106.5Z",
    fill: "#EFEFF0",
    mask: "url(#path-1605-inside-2_1593_3270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.524 75.085C105.592 75.1306 105.648 75.1924 105.687 75.2647C105.726 75.3371 105.746 75.4179 105.746 75.5V83C105.746 83.0999 105.716 83.1974 105.66 83.2801C105.604 83.3628 105.525 83.4269 105.432 83.464L105.429 83.465L105.423 83.468L105.4 83.477C105.269 83.5293 105.136 83.5793 105.003 83.627C104.739 83.722 104.372 83.85 103.956 83.977C103.14 84.229 102.077 84.5 101.246 84.5C100.399 84.5 99.6981 84.22 99.0881 83.975L99.0601 83.965C98.4261 83.71 97.8861 83.5 97.2461 83.5C96.5461 83.5 95.6081 83.73 94.8091 83.977C94.4513 84.0885 94.0969 84.2102 93.7461 84.342V90.5C93.7461 90.6326 93.6934 90.7598 93.5996 90.8536C93.5059 90.9473 93.3787 91 93.2461 91C93.1135 91 92.9863 90.9473 92.8925 90.8536C92.7988 90.7598 92.7461 90.6326 92.7461 90.5V75.5C92.7461 75.3674 92.7988 75.2402 92.8925 75.1464C92.9863 75.0527 93.1135 75 93.2461 75C93.3787 75 93.5059 75.0527 93.5996 75.1464C93.6934 75.2402 93.7461 75.3674 93.7461 75.5V75.782C93.9721 75.703 94.2421 75.612 94.5361 75.522C95.3521 75.272 96.4161 75 97.2461 75C98.0861 75 98.7701 75.277 99.3671 75.519L99.4101 75.537C100.032 75.788 100.574 76 101.246 76C101.946 76 102.884 75.77 103.683 75.523C104.138 75.3808 104.588 75.222 105.032 75.047L105.051 75.04L105.055 75.038H105.056",
    fill: "#96A2C2"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1608-inside-3_1593_3270",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2461 107.5H116.246V155.5H67.2461V107.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.2461 107.5H116.246V155.5H67.2461V107.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.246 154.5H67.2461V156.5H116.246V154.5Z",
    fill: "#EFEFF0",
    mask: "url(#path-1608-inside-3_1593_3270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.024 123.085C103.092 123.131 103.148 123.192 103.187 123.265C103.226 123.337 103.246 123.418 103.246 123.5V131C103.246 131.1 103.216 131.197 103.16 131.28C103.104 131.363 103.025 131.427 102.932 131.464L102.929 131.465L102.923 131.468L102.9 131.477C102.769 131.529 102.636 131.579 102.503 131.627C102.239 131.722 101.872 131.85 101.456 131.977C100.64 132.229 99.5771 132.5 98.7461 132.5C97.8991 132.5 97.1981 132.22 96.5881 131.975L96.5601 131.965C95.9261 131.71 95.3861 131.5 94.7461 131.5C94.0461 131.5 93.1081 131.73 92.3091 131.977C91.9513 132.088 91.5969 132.21 91.2461 132.342V138.5C91.2461 138.633 91.1934 138.76 91.0996 138.854C91.0059 138.947 90.8787 139 90.7461 139C90.6135 139 90.4863 138.947 90.3925 138.854C90.2988 138.76 90.2461 138.633 90.2461 138.5V123.5C90.2461 123.367 90.2988 123.24 90.3925 123.146C90.4863 123.053 90.6135 123 90.7461 123C90.8787 123 91.0059 123.053 91.0996 123.146C91.1934 123.24 91.2461 123.367 91.2461 123.5V123.782C91.4721 123.703 91.7421 123.612 92.0361 123.522C92.8521 123.272 93.9161 123 94.7461 123C95.5861 123 96.2701 123.277 96.8671 123.519L96.9101 123.537C97.5321 123.788 98.0741 124 98.7461 124C99.4461 124 100.384 123.77 101.183 123.523C101.638 123.381 102.088 123.222 102.532 123.047L102.551 123.04L102.555 123.038H102.556",
    fill: "#96A2C2"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1611-inside-4_1593_3270",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2461 155.5H116.246V203.5H67.2461V155.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.2461 155.5H116.246V203.5H67.2461V155.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.246 202.5H67.2461V204.5H116.246V202.5Z",
    fill: "#EFEFF0",
    mask: "url(#path-1611-inside-4_1593_3270)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 227,
    height: 184,
    transform: "translate(116.246 19.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1613-inside-5_1593_3270",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.246 19.5H343.246V59.5H116.246V19.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.246 19.5H343.246V59.5H116.246V19.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.246 58.5H116.246V60.5H343.246V58.5Z",
    fill: "#EFEFF0",
    mask: "url(#path-1613-inside-5_1593_3270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.336 43.5H128.95V33.588H132.128C132.604 33.588 133.057 33.6393 133.486 33.742C133.915 33.8353 134.289 33.9893 134.606 34.204C134.933 34.4187 135.189 34.7033 135.376 35.058C135.563 35.4033 135.656 35.828 135.656 36.332C135.656 37.06 135.432 37.648 134.984 38.096C134.536 38.544 133.957 38.8287 133.248 38.95L136.02 43.5H134.34L131.82 39.09H130.336V43.5ZM130.336 37.928H131.932C132.259 37.928 132.562 37.9 132.842 37.844C133.122 37.788 133.365 37.6993 133.57 37.578C133.785 37.4473 133.953 37.284 134.074 37.088C134.195 36.8827 134.256 36.6307 134.256 36.332C134.256 36.0333 134.195 35.786 134.074 35.59C133.953 35.3847 133.789 35.2213 133.584 35.1C133.388 34.9787 133.155 34.8947 132.884 34.848C132.613 34.792 132.329 34.764 132.03 34.764H130.336V37.928ZM142.174 39.594C142.164 39.3327 142.118 39.09 142.034 38.866C141.959 38.6327 141.842 38.432 141.684 38.264C141.534 38.096 141.343 37.9653 141.11 37.872C140.886 37.7693 140.62 37.718 140.312 37.718C140.032 37.718 139.766 37.7693 139.514 37.872C139.271 37.9653 139.056 38.096 138.87 38.264C138.692 38.432 138.543 38.6327 138.422 38.866C138.31 39.09 138.244 39.3327 138.226 39.594H142.174ZM143.504 40.126C143.504 40.2007 143.504 40.2753 143.504 40.35C143.504 40.4247 143.499 40.4993 143.49 40.574H138.226C138.235 40.854 138.296 41.12 138.408 41.372C138.529 41.6147 138.688 41.8293 138.884 42.016C139.08 42.1933 139.304 42.3333 139.556 42.436C139.817 42.5387 140.092 42.59 140.382 42.59C140.83 42.59 141.217 42.492 141.544 42.296C141.87 42.1 142.127 41.862 142.314 41.582L143.238 42.324C142.883 42.7907 142.463 43.136 141.978 43.36C141.502 43.5747 140.97 43.682 140.382 43.682C139.878 43.682 139.411 43.598 138.982 43.43C138.552 43.262 138.184 43.0287 137.876 42.73C137.568 42.422 137.325 42.0533 137.148 41.624C136.97 41.1947 136.882 40.7187 136.882 40.196C136.882 39.6827 136.966 39.2113 137.134 38.782C137.311 38.3433 137.554 37.97 137.862 37.662C138.17 37.354 138.534 37.116 138.954 36.948C139.374 36.7707 139.826 36.682 140.312 36.682C140.797 36.682 141.236 36.7613 141.628 36.92C142.029 37.0787 142.365 37.3073 142.636 37.606C142.916 37.9047 143.13 38.2687 143.28 38.698C143.429 39.118 143.504 39.594 143.504 40.126ZM146.657 46.86H145.341V36.864H146.629V37.9H146.671C146.886 37.5453 147.198 37.256 147.609 37.032C148.029 36.7987 148.514 36.682 149.065 36.682C149.56 36.682 150.008 36.7707 150.409 36.948C150.82 37.1253 151.17 37.3727 151.459 37.69C151.758 38.0073 151.986 38.3807 152.145 38.81C152.304 39.23 152.383 39.6827 152.383 40.168C152.383 40.6533 152.304 41.1107 152.145 41.54C151.986 41.9693 151.762 42.3427 151.473 42.66C151.184 42.9773 150.834 43.2293 150.423 43.416C150.012 43.5933 149.55 43.682 149.037 43.682C148.561 43.682 148.113 43.5793 147.693 43.374C147.273 43.1687 146.942 42.8793 146.699 42.506H146.657V46.86ZM151.025 40.168C151.025 39.86 150.978 39.5613 150.885 39.272C150.792 38.9827 150.652 38.726 150.465 38.502C150.278 38.278 150.045 38.1007 149.765 37.97C149.494 37.8393 149.177 37.774 148.813 37.774C148.477 37.774 148.169 37.8393 147.889 37.97C147.618 38.1007 147.385 38.278 147.189 38.502C146.993 38.726 146.839 38.9827 146.727 39.272C146.624 39.5613 146.573 39.8647 146.573 40.182C146.573 40.4993 146.624 40.8027 146.727 41.092C146.839 41.3813 146.993 41.638 147.189 41.862C147.385 42.0767 147.618 42.2493 147.889 42.38C148.169 42.5107 148.477 42.576 148.813 42.576C149.177 42.576 149.494 42.5107 149.765 42.38C150.045 42.24 150.278 42.058 150.465 41.834C150.652 41.61 150.792 41.3533 150.885 41.064C150.978 40.7747 151.025 40.476 151.025 40.168ZM160.934 40.168C160.934 40.6813 160.841 41.1527 160.654 41.582C160.477 42.0113 160.225 42.3847 159.898 42.702C159.581 43.01 159.203 43.2527 158.764 43.43C158.325 43.598 157.854 43.682 157.35 43.682C156.846 43.682 156.375 43.598 155.936 43.43C155.497 43.2527 155.119 43.01 154.802 42.702C154.485 42.3847 154.233 42.0113 154.046 41.582C153.869 41.1527 153.78 40.6813 153.78 40.168C153.78 39.6547 153.869 39.188 154.046 38.768C154.233 38.3387 154.485 37.97 154.802 37.662C155.119 37.354 155.497 37.116 155.936 36.948C156.375 36.7707 156.846 36.682 157.35 36.682C157.854 36.682 158.325 36.7707 158.764 36.948C159.203 37.116 159.581 37.354 159.898 37.662C160.225 37.97 160.477 38.3387 160.654 38.768C160.841 39.188 160.934 39.6547 160.934 40.168ZM159.562 40.168C159.562 39.8507 159.511 39.5473 159.408 39.258C159.315 38.9687 159.175 38.7167 158.988 38.502C158.801 38.278 158.568 38.1007 158.288 37.97C158.017 37.8393 157.705 37.774 157.35 37.774C156.995 37.774 156.678 37.8393 156.398 37.97C156.127 38.1007 155.899 38.278 155.712 38.502C155.525 38.7167 155.381 38.9687 155.278 39.258C155.185 39.5473 155.138 39.8507 155.138 40.168C155.138 40.4853 155.185 40.7887 155.278 41.078C155.381 41.3673 155.525 41.624 155.712 41.848C155.899 42.072 156.127 42.2493 156.398 42.38C156.678 42.5107 156.995 42.576 157.35 42.576C157.705 42.576 158.017 42.5107 158.288 42.38C158.568 42.2493 158.801 42.072 158.988 41.848C159.175 41.624 159.315 41.3673 159.408 41.078C159.511 40.7887 159.562 40.4853 159.562 40.168ZM162.759 38.292C162.759 38.1147 162.754 37.886 162.745 37.606C162.736 37.326 162.722 37.0787 162.703 36.864H163.949C163.968 37.032 163.982 37.228 163.991 37.452C164 37.6667 164.005 37.844 164.005 37.984H164.047C164.234 37.592 164.504 37.2793 164.859 37.046C165.223 36.8033 165.629 36.682 166.077 36.682C166.282 36.682 166.455 36.7007 166.595 36.738L166.539 37.956C166.352 37.9093 166.152 37.886 165.937 37.886C165.62 37.886 165.344 37.9467 165.111 38.068C164.878 38.18 164.682 38.334 164.523 38.53C164.374 38.726 164.262 38.9547 164.187 39.216C164.112 39.468 164.075 39.734 164.075 40.014V43.5H162.759V38.292ZM170.915 37.942H169.151V41.4C169.151 41.8013 169.226 42.0907 169.375 42.268C169.525 42.436 169.763 42.52 170.089 42.52C170.211 42.52 170.341 42.506 170.481 42.478C170.621 42.45 170.747 42.408 170.859 42.352L170.901 43.43C170.743 43.486 170.565 43.528 170.369 43.556C170.183 43.5933 169.987 43.612 169.781 43.612C169.156 43.612 168.675 43.4393 168.339 43.094C168.013 42.7487 167.849 42.2307 167.849 41.54V37.942H166.575V36.864H167.849V34.96H169.151V36.864H170.915V37.942ZM176.965 36.864C176.983 37.032 176.997 37.2233 177.007 37.438C177.016 37.6433 177.021 37.816 177.021 37.956H177.063C177.147 37.7787 177.259 37.6153 177.399 37.466C177.548 37.3073 177.716 37.172 177.903 37.06C178.089 36.9387 178.295 36.8453 178.519 36.78C178.743 36.7147 178.976 36.682 179.219 36.682C179.648 36.682 180.017 36.7567 180.325 36.906C180.633 37.046 180.889 37.2373 181.095 37.48C181.3 37.7227 181.449 38.0073 181.543 38.334C181.645 38.6607 181.697 39.0107 181.697 39.384V43.5H180.381V39.818C180.381 39.5473 180.357 39.2907 180.311 39.048C180.273 38.8053 180.199 38.5907 180.087 38.404C179.975 38.2173 179.821 38.068 179.625 37.956C179.429 37.844 179.177 37.788 178.869 37.788C178.346 37.788 177.917 37.9887 177.581 38.39C177.254 38.782 177.091 39.3093 177.091 39.972V43.5H175.775V38.292C175.775 38.1147 175.77 37.886 175.761 37.606C175.751 37.326 175.737 37.0787 175.719 36.864H176.965ZM188.053 39.202C188.053 38.7073 187.904 38.3433 187.605 38.11C187.306 37.8673 186.91 37.746 186.415 37.746C186.042 37.746 185.687 37.8207 185.351 37.97C185.024 38.11 184.749 38.292 184.525 38.516L183.825 37.676C184.152 37.368 184.548 37.1253 185.015 36.948C185.491 36.7707 186 36.682 186.541 36.682C187.017 36.682 187.428 36.752 187.773 36.892C188.128 37.0227 188.417 37.2047 188.641 37.438C188.865 37.6713 189.033 37.9467 189.145 38.264C189.257 38.5813 189.313 38.922 189.313 39.286V42.184C189.313 42.408 189.318 42.646 189.327 42.898C189.346 43.1407 189.374 43.3413 189.411 43.5H188.221C188.146 43.1827 188.109 42.8653 188.109 42.548H188.067C187.824 42.9027 187.516 43.178 187.143 43.374C186.779 43.57 186.345 43.668 185.841 43.668C185.58 43.668 185.304 43.6307 185.015 43.556C184.735 43.4907 184.478 43.3787 184.245 43.22C184.012 43.0613 183.816 42.8513 183.657 42.59C183.508 42.3287 183.433 42.0067 183.433 41.624C183.433 41.12 183.568 40.7233 183.839 40.434C184.11 40.1353 184.464 39.9113 184.903 39.762C185.342 39.6033 185.836 39.5007 186.387 39.454C186.938 39.4073 187.493 39.384 188.053 39.384V39.202ZM187.731 40.336C187.404 40.336 187.064 40.35 186.709 40.378C186.364 40.406 186.046 40.462 185.757 40.546C185.477 40.63 185.244 40.756 185.057 40.924C184.87 41.092 184.777 41.316 184.777 41.596C184.777 41.792 184.814 41.9553 184.889 42.086C184.973 42.2167 185.08 42.324 185.211 42.408C185.342 42.492 185.486 42.5527 185.645 42.59C185.804 42.618 185.967 42.632 186.135 42.632C186.751 42.632 187.222 42.45 187.549 42.086C187.885 41.7127 188.053 41.246 188.053 40.686V40.336H187.731ZM192.799 37.956C192.967 37.6013 193.233 37.3027 193.597 37.06C193.97 36.808 194.409 36.682 194.913 36.682C195.361 36.682 195.762 36.7847 196.117 36.99C196.481 37.1953 196.766 37.536 196.971 38.012C197.195 37.5827 197.508 37.256 197.909 37.032C198.31 36.7987 198.749 36.682 199.225 36.682C199.654 36.682 200.023 36.7567 200.331 36.906C200.639 37.046 200.896 37.2373 201.101 37.48C201.306 37.7227 201.456 38.0073 201.549 38.334C201.652 38.6607 201.703 39.0107 201.703 39.384V43.5H200.387V39.818C200.387 39.5473 200.364 39.2907 200.317 39.048C200.27 38.8053 200.191 38.5907 200.079 38.404C199.967 38.2173 199.818 38.068 199.631 37.956C199.444 37.844 199.206 37.788 198.917 37.788C198.618 37.788 198.362 37.8533 198.147 37.984C197.932 38.1053 197.755 38.2687 197.615 38.474C197.484 38.67 197.386 38.894 197.321 39.146C197.265 39.398 197.237 39.6547 197.237 39.916V43.5H195.921V39.552C195.921 39.2907 195.898 39.0527 195.851 38.838C195.804 38.6233 195.725 38.4413 195.613 38.292C195.501 38.1333 195.356 38.012 195.179 37.928C195.002 37.8347 194.782 37.788 194.521 37.788C194.036 37.788 193.63 37.9887 193.303 38.39C192.986 38.782 192.827 39.3093 192.827 39.972V43.5H191.511V38.292C191.511 38.1147 191.506 37.886 191.497 37.606C191.488 37.326 191.474 37.0787 191.455 36.864H192.701C192.72 37.032 192.734 37.2233 192.743 37.438C192.752 37.6433 192.757 37.816 192.757 37.956H192.799ZM208.783 39.594C208.774 39.3327 208.727 39.09 208.643 38.866C208.568 38.6327 208.452 38.432 208.293 38.264C208.144 38.096 207.952 37.9653 207.719 37.872C207.495 37.7693 207.229 37.718 206.921 37.718C206.641 37.718 206.375 37.7693 206.123 37.872C205.88 37.9653 205.666 38.096 205.479 38.264C205.302 38.432 205.152 38.6327 205.031 38.866C204.919 39.09 204.854 39.3327 204.835 39.594H208.783ZM210.113 40.126C210.113 40.2007 210.113 40.2753 210.113 40.35C210.113 40.4247 210.108 40.4993 210.099 40.574H204.835C204.844 40.854 204.905 41.12 205.017 41.372C205.138 41.6147 205.297 41.8293 205.493 42.016C205.689 42.1933 205.913 42.3333 206.165 42.436C206.426 42.5387 206.702 42.59 206.991 42.59C207.439 42.59 207.826 42.492 208.153 42.296C208.48 42.1 208.736 41.862 208.923 41.582L209.847 42.324C209.492 42.7907 209.072 43.136 208.587 43.36C208.111 43.5747 207.579 43.682 206.991 43.682C206.487 43.682 206.02 43.598 205.591 43.43C205.162 43.262 204.793 43.0287 204.485 42.73C204.177 42.422 203.934 42.0533 203.757 41.624C203.58 41.1947 203.491 40.7187 203.491 40.196C203.491 39.6827 203.575 39.2113 203.743 38.782C203.92 38.3433 204.163 37.97 204.471 37.662C204.779 37.354 205.143 37.116 205.563 36.948C205.983 36.7707 206.436 36.682 206.921 36.682C207.406 36.682 207.845 36.7613 208.237 36.92C208.638 37.0787 208.974 37.3073 209.245 37.606C209.525 37.9047 209.74 38.2687 209.889 38.698C210.038 39.118 210.113 39.594 210.113 40.126Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1616-inside-6_1593_3270",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.246 59.5H343.246V107.5H116.246V59.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.246 59.5H343.246V107.5H116.246V59.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.246 106.5H116.246V108.5H343.246V106.5Z",
    fill: "#EFEFF0",
    mask: "url(#path-1616-inside-6_1593_3270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.864 79.184C136.649 78.8853 136.374 78.6473 136.038 78.47C135.702 78.2833 135.296 78.19 134.82 78.19C134.577 78.19 134.33 78.2273 134.078 78.302C133.826 78.3767 133.597 78.4933 133.392 78.652C133.187 78.8013 133.019 78.9927 132.888 79.226C132.767 79.4593 132.706 79.7347 132.706 80.052C132.706 80.3693 132.767 80.6307 132.888 80.836C133.009 81.0413 133.168 81.2187 133.364 81.368C133.569 81.508 133.798 81.6247 134.05 81.718C134.311 81.8113 134.582 81.9047 134.862 81.998C135.207 82.11 135.553 82.2313 135.898 82.362C136.253 82.4927 136.57 82.6653 136.85 82.88C137.13 83.0853 137.359 83.3513 137.536 83.678C137.713 83.9953 137.802 84.4013 137.802 84.896C137.802 85.3907 137.704 85.82 137.508 86.184C137.321 86.5387 137.074 86.8327 136.766 87.066C136.467 87.2993 136.122 87.472 135.73 87.584C135.347 87.696 134.96 87.752 134.568 87.752C134.269 87.752 133.971 87.7193 133.672 87.654C133.373 87.598 133.089 87.5093 132.818 87.388C132.547 87.2667 132.295 87.1127 132.062 86.926C131.829 86.7393 131.623 86.5247 131.446 86.282L132.314 85.638C132.529 85.9927 132.827 86.2913 133.21 86.534C133.602 86.7673 134.059 86.884 134.582 86.884C134.834 86.884 135.091 86.8467 135.352 86.772C135.613 86.688 135.847 86.5667 136.052 86.408C136.267 86.24 136.439 86.0393 136.57 85.806C136.71 85.5633 136.78 85.2833 136.78 84.966C136.78 84.6207 136.71 84.336 136.57 84.112C136.439 83.8787 136.262 83.6873 136.038 83.538C135.814 83.3793 135.557 83.2487 135.268 83.146C134.979 83.0433 134.675 82.9407 134.358 82.838C134.031 82.7353 133.709 82.6187 133.392 82.488C133.075 82.3573 132.79 82.1893 132.538 81.984C132.286 81.7693 132.081 81.508 131.922 81.2C131.773 80.892 131.698 80.514 131.698 80.066C131.698 79.59 131.791 79.1793 131.978 78.834C132.174 78.4887 132.426 78.204 132.734 77.98C133.042 77.756 133.383 77.5927 133.756 77.49C134.129 77.3873 134.498 77.336 134.862 77.336C135.534 77.336 136.108 77.4573 136.584 77.7C137.06 77.9333 137.419 78.2133 137.662 78.54L136.864 79.184ZM144.906 83.72C144.878 83.104 144.678 82.5953 144.304 82.194C143.94 81.7833 143.418 81.578 142.736 81.578C142.419 81.578 142.125 81.6387 141.854 81.76C141.584 81.872 141.346 82.0307 141.14 82.236C140.935 82.432 140.772 82.6607 140.65 82.922C140.529 83.174 140.459 83.44 140.44 83.72H144.906ZM145.872 84.028C145.872 84.0933 145.872 84.1633 145.872 84.238C145.872 84.3127 145.868 84.392 145.858 84.476H140.426C140.436 84.8027 140.501 85.1107 140.622 85.4C140.744 85.6893 140.912 85.9413 141.126 86.156C141.341 86.3707 141.593 86.5433 141.882 86.674C142.172 86.7953 142.484 86.856 142.82 86.856C143.315 86.856 143.74 86.744 144.094 86.52C144.458 86.2867 144.734 86.0207 144.92 85.722L145.634 86.282C145.242 86.7767 144.808 87.1313 144.332 87.346C143.866 87.5607 143.362 87.668 142.82 87.668C142.335 87.668 141.882 87.584 141.462 87.416C141.052 87.2387 140.697 86.996 140.398 86.688C140.1 86.38 139.862 86.016 139.684 85.596C139.516 85.176 139.432 84.7187 139.432 84.224C139.432 83.7293 139.516 83.272 139.684 82.852C139.852 82.432 140.086 82.068 140.384 81.76C140.683 81.452 141.033 81.214 141.434 81.046C141.836 80.8687 142.27 80.78 142.736 80.78C143.25 80.78 143.702 80.8687 144.094 81.046C144.486 81.214 144.813 81.4473 145.074 81.746C145.336 82.0353 145.532 82.376 145.662 82.768C145.802 83.16 145.872 83.58 145.872 84.028ZM148.872 90.86H147.92V80.948H148.872V82.082H148.914C149.185 81.6527 149.544 81.3307 149.992 81.116C150.449 80.892 150.911 80.78 151.378 80.78C151.891 80.78 152.353 80.8687 152.764 81.046C153.184 81.2233 153.539 81.466 153.828 81.774C154.127 82.082 154.355 82.446 154.514 82.866C154.682 83.286 154.766 83.7387 154.766 84.224C154.766 84.7093 154.682 85.162 154.514 85.582C154.355 86.002 154.127 86.366 153.828 86.674C153.539 86.982 153.184 87.2247 152.764 87.402C152.353 87.5793 151.891 87.668 151.378 87.668C150.911 87.668 150.449 87.5607 149.992 87.346C149.544 87.122 149.185 86.8047 148.914 86.394H148.872V90.86ZM153.758 84.224C153.758 83.86 153.702 83.5193 153.59 83.202C153.478 82.8753 153.315 82.5953 153.1 82.362C152.895 82.1193 152.638 81.928 152.33 81.788C152.022 81.648 151.672 81.578 151.28 81.578C150.916 81.578 150.58 81.648 150.272 81.788C149.964 81.9187 149.698 82.1053 149.474 82.348C149.25 82.5813 149.073 82.8613 148.942 83.188C148.821 83.5053 148.76 83.8507 148.76 84.224C148.76 84.5973 148.821 84.9473 148.942 85.274C149.073 85.5913 149.25 85.8667 149.474 86.1C149.698 86.3333 149.964 86.52 150.272 86.66C150.58 86.7907 150.916 86.856 151.28 86.856C151.672 86.856 152.022 86.7907 152.33 86.66C152.638 86.52 152.895 86.3333 153.1 86.1C153.315 85.8573 153.478 85.5773 153.59 85.26C153.702 84.9333 153.758 84.588 153.758 84.224ZM159.761 81.746H157.913V85.568C157.913 85.8107 157.936 86.0113 157.983 86.17C158.03 86.3287 158.095 86.4547 158.179 86.548C158.272 86.632 158.38 86.6927 158.501 86.73C158.622 86.758 158.753 86.772 158.893 86.772C159.024 86.772 159.159 86.7533 159.299 86.716C159.448 86.6787 159.588 86.6273 159.719 86.562L159.761 87.388C159.593 87.4533 159.416 87.5 159.229 87.528C159.052 87.5653 158.856 87.584 158.641 87.584C158.464 87.584 158.277 87.5607 158.081 87.514C157.885 87.4673 157.703 87.3787 157.535 87.248C157.367 87.1173 157.227 86.94 157.115 86.716C157.012 86.492 156.961 86.198 156.961 85.834V81.746H155.603V80.948H156.961V79.1H157.913V80.948H159.761V81.746ZM166.248 83.72C166.22 83.104 166.02 82.5953 165.646 82.194C165.282 81.7833 164.76 81.578 164.078 81.578C163.761 81.578 163.467 81.6387 163.196 81.76C162.926 81.872 162.688 82.0307 162.482 82.236C162.277 82.432 162.114 82.6607 161.992 82.922C161.871 83.174 161.801 83.44 161.782 83.72H166.248ZM167.214 84.028C167.214 84.0933 167.214 84.1633 167.214 84.238C167.214 84.3127 167.21 84.392 167.2 84.476H161.768C161.778 84.8027 161.843 85.1107 161.964 85.4C162.086 85.6893 162.254 85.9413 162.468 86.156C162.683 86.3707 162.935 86.5433 163.224 86.674C163.514 86.7953 163.826 86.856 164.162 86.856C164.657 86.856 165.082 86.744 165.436 86.52C165.8 86.2867 166.076 86.0207 166.262 85.722L166.976 86.282C166.584 86.7767 166.15 87.1313 165.674 87.346C165.208 87.5607 164.704 87.668 164.162 87.668C163.677 87.668 163.224 87.584 162.804 87.416C162.394 87.2387 162.039 86.996 161.74 86.688C161.442 86.38 161.204 86.016 161.026 85.596C160.858 85.176 160.774 84.7187 160.774 84.224C160.774 83.7293 160.858 83.272 161.026 82.852C161.194 82.432 161.428 82.068 161.726 81.76C162.025 81.452 162.375 81.214 162.776 81.046C163.178 80.8687 163.612 80.78 164.078 80.78C164.592 80.78 165.044 80.8687 165.436 81.046C165.828 81.214 166.155 81.4473 166.416 81.746C166.678 82.0353 166.874 82.376 167.004 82.768C167.144 83.16 167.214 83.58 167.214 84.028ZM170.2 82.068C170.387 81.6853 170.671 81.3773 171.054 81.144C171.446 80.9013 171.88 80.78 172.356 80.78C172.533 80.78 172.715 80.7987 172.902 80.836C173.098 80.8733 173.285 80.948 173.462 81.06C173.649 81.1627 173.817 81.3027 173.966 81.48C174.125 81.6573 174.26 81.886 174.372 82.166C174.596 81.718 174.899 81.3773 175.282 81.144C175.674 80.9013 176.136 80.78 176.668 80.78C177.499 80.78 178.119 81.0273 178.53 81.522C178.95 82.0167 179.16 82.67 179.16 83.482V87.5H178.208V83.874C178.208 83.1833 178.077 82.628 177.816 82.208C177.564 81.788 177.13 81.578 176.514 81.578C176.169 81.578 175.875 81.648 175.632 81.788C175.399 81.928 175.207 82.1147 175.058 82.348C174.918 82.572 174.815 82.8287 174.75 83.118C174.685 83.4073 174.652 83.706 174.652 84.014V87.5H173.7V83.678C173.7 83.3607 173.677 83.0713 173.63 82.81C173.583 82.5487 173.499 82.3293 173.378 82.152C173.266 81.9653 173.107 81.8253 172.902 81.732C172.697 81.6293 172.435 81.578 172.118 81.578C171.894 81.578 171.665 81.6293 171.432 81.732C171.208 81.8347 171.003 81.9933 170.816 82.208C170.639 82.4133 170.494 82.6793 170.382 83.006C170.27 83.3233 170.214 83.7013 170.214 84.14V87.5H169.262V82.39C169.262 82.2127 169.257 81.984 169.248 81.704C169.239 81.424 169.225 81.172 169.206 80.948H170.116C170.135 81.1253 170.149 81.3213 170.158 81.536C170.167 81.7507 170.172 81.928 170.172 82.068H170.2ZM182.601 86.394V87.5H181.649V76.916H182.601V82.082H182.629C182.909 81.6527 183.273 81.3307 183.721 81.116C184.169 80.892 184.631 80.78 185.107 80.78C185.621 80.78 186.083 80.8687 186.493 81.046C186.913 81.2233 187.268 81.466 187.557 81.774C187.856 82.082 188.085 82.446 188.243 82.866C188.411 83.286 188.495 83.7387 188.495 84.224C188.495 84.7093 188.411 85.162 188.243 85.582C188.085 86.002 187.856 86.366 187.557 86.674C187.268 86.982 186.913 87.2247 186.493 87.402C186.083 87.5793 185.621 87.668 185.107 87.668C184.631 87.668 184.169 87.5607 183.721 87.346C183.273 87.1313 182.909 86.814 182.629 86.394H182.601ZM187.487 84.224C187.487 83.86 187.431 83.5193 187.319 83.202C187.207 82.8753 187.044 82.5953 186.829 82.362C186.624 82.1193 186.367 81.928 186.059 81.788C185.751 81.648 185.401 81.578 185.009 81.578C184.645 81.578 184.309 81.648 184.001 81.788C183.693 81.9187 183.427 82.1053 183.203 82.348C182.979 82.5813 182.802 82.8613 182.671 83.188C182.55 83.5053 182.489 83.8507 182.489 84.224C182.489 84.5973 182.55 84.9473 182.671 85.274C182.802 85.5913 182.979 85.8667 183.203 86.1C183.427 86.3333 183.693 86.52 184.001 86.66C184.309 86.7907 184.645 86.856 185.009 86.856C185.401 86.856 185.751 86.7907 186.059 86.66C186.367 86.52 186.624 86.3333 186.829 86.1C187.044 85.8573 187.207 85.5773 187.319 85.26C187.431 84.9333 187.487 84.588 187.487 84.224ZM195.533 83.72C195.505 83.104 195.305 82.5953 194.931 82.194C194.567 81.7833 194.045 81.578 193.363 81.578C193.046 81.578 192.752 81.6387 192.481 81.76C192.211 81.872 191.973 82.0307 191.767 82.236C191.562 82.432 191.399 82.6607 191.277 82.922C191.156 83.174 191.086 83.44 191.067 83.72H195.533ZM196.499 84.028C196.499 84.0933 196.499 84.1633 196.499 84.238C196.499 84.3127 196.495 84.392 196.485 84.476H191.053C191.063 84.8027 191.128 85.1107 191.249 85.4C191.371 85.6893 191.539 85.9413 191.753 86.156C191.968 86.3707 192.22 86.5433 192.509 86.674C192.799 86.7953 193.111 86.856 193.447 86.856C193.942 86.856 194.367 86.744 194.721 86.52C195.085 86.2867 195.361 86.0207 195.547 85.722L196.261 86.282C195.869 86.7767 195.435 87.1313 194.959 87.346C194.493 87.5607 193.989 87.668 193.447 87.668C192.962 87.668 192.509 87.584 192.089 87.416C191.679 87.2387 191.324 86.996 191.025 86.688C190.727 86.38 190.489 86.016 190.311 85.596C190.143 85.176 190.059 84.7187 190.059 84.224C190.059 83.7293 190.143 83.272 190.311 82.852C190.479 82.432 190.713 82.068 191.011 81.76C191.31 81.452 191.66 81.214 192.061 81.046C192.463 80.8687 192.897 80.78 193.363 80.78C193.877 80.78 194.329 80.8687 194.721 81.046C195.113 81.214 195.44 81.4473 195.701 81.746C195.963 82.0353 196.159 82.376 196.289 82.768C196.429 83.16 196.499 83.58 196.499 84.028ZM198.547 82.39C198.547 82.2127 198.542 81.984 198.533 81.704C198.524 81.424 198.51 81.172 198.491 80.948H199.401C199.42 81.1253 199.434 81.3213 199.443 81.536C199.452 81.7507 199.457 81.928 199.457 82.068H199.485C199.672 81.6853 199.952 81.3773 200.325 81.144C200.698 80.9013 201.118 80.78 201.585 80.78C201.706 80.78 201.814 80.7847 201.907 80.794C202.01 80.8033 202.112 80.822 202.215 80.85L202.089 81.746C202.033 81.7273 201.94 81.7087 201.809 81.69C201.678 81.6713 201.548 81.662 201.417 81.662C201.165 81.662 200.922 81.7087 200.689 81.802C200.456 81.8953 200.25 82.0447 200.073 82.25C199.905 82.446 199.765 82.7027 199.653 83.02C199.55 83.328 199.499 83.7013 199.499 84.14V87.5H198.547V82.39ZM208.03 82.068C208.217 81.6853 208.501 81.3773 208.884 81.144C209.276 80.9013 209.71 80.78 210.186 80.78C210.363 80.78 210.545 80.7987 210.732 80.836C210.928 80.8733 211.115 80.948 211.292 81.06C211.479 81.1627 211.647 81.3027 211.796 81.48C211.955 81.6573 212.09 81.886 212.202 82.166C212.426 81.718 212.729 81.3773 213.112 81.144C213.504 80.9013 213.966 80.78 214.498 80.78C215.329 80.78 215.949 81.0273 216.36 81.522C216.78 82.0167 216.99 82.67 216.99 83.482V87.5H216.038V83.874C216.038 83.1833 215.907 82.628 215.646 82.208C215.394 81.788 214.96 81.578 214.344 81.578C213.999 81.578 213.705 81.648 213.462 81.788C213.229 81.928 213.037 82.1147 212.888 82.348C212.748 82.572 212.645 82.8287 212.58 83.118C212.515 83.4073 212.482 83.706 212.482 84.014V87.5H211.53V83.678C211.53 83.3607 211.507 83.0713 211.46 82.81C211.413 82.5487 211.329 82.3293 211.208 82.152C211.096 81.9653 210.937 81.8253 210.732 81.732C210.527 81.6293 210.265 81.578 209.948 81.578C209.724 81.578 209.495 81.6293 209.262 81.732C209.038 81.8347 208.833 81.9933 208.646 82.208C208.469 82.4133 208.324 82.6793 208.212 83.006C208.1 83.3233 208.044 83.7013 208.044 84.14V87.5H207.092V82.39C207.092 82.2127 207.087 81.984 207.078 81.704C207.069 81.424 207.055 81.172 207.036 80.948H207.946C207.965 81.1253 207.979 81.3213 207.988 81.536C207.997 81.7507 208.002 81.928 208.002 82.068H208.03ZM220.417 87.5H219.465V80.948H220.417V87.5ZM220.613 78.428C220.613 78.624 220.543 78.7873 220.403 78.918C220.263 79.0393 220.109 79.1 219.941 79.1C219.773 79.1 219.619 79.0393 219.479 78.918C219.339 78.7873 219.269 78.624 219.269 78.428C219.269 78.232 219.339 78.0733 219.479 77.952C219.619 77.8213 219.773 77.756 219.941 77.756C220.109 77.756 220.263 77.8213 220.403 77.952C220.543 78.0733 220.613 78.232 220.613 78.428ZM223.931 87.5H222.979V76.916H223.931V87.5ZM231.477 83.72C231.449 83.104 231.248 82.5953 230.875 82.194C230.511 81.7833 229.988 81.578 229.307 81.578C228.989 81.578 228.695 81.6387 228.425 81.76C228.154 81.872 227.916 82.0307 227.711 82.236C227.505 82.432 227.342 82.6607 227.221 82.922C227.099 83.174 227.029 83.44 227.011 83.72H231.477ZM232.443 84.028C232.443 84.0933 232.443 84.1633 232.443 84.238C232.443 84.3127 232.438 84.392 232.429 84.476H226.997C227.006 84.8027 227.071 85.1107 227.193 85.4C227.314 85.6893 227.482 85.9413 227.697 86.156C227.911 86.3707 228.163 86.5433 228.453 86.674C228.742 86.7953 229.055 86.856 229.391 86.856C229.885 86.856 230.31 86.744 230.665 86.52C231.029 86.2867 231.304 86.0207 231.491 85.722L232.205 86.282C231.813 86.7767 231.379 87.1313 230.903 87.346C230.436 87.5607 229.932 87.668 229.391 87.668C228.905 87.668 228.453 87.584 228.033 87.416C227.622 87.2387 227.267 86.996 226.969 86.688C226.67 86.38 226.432 86.016 226.255 85.596C226.087 85.176 226.003 84.7187 226.003 84.224C226.003 83.7293 226.087 83.272 226.255 82.852C226.423 82.432 226.656 82.068 226.955 81.76C227.253 81.452 227.603 81.214 228.005 81.046C228.406 80.8687 228.84 80.78 229.307 80.78C229.82 80.78 230.273 80.8687 230.665 81.046C231.057 81.214 231.383 81.4473 231.645 81.746C231.906 82.0353 232.102 82.376 232.233 82.768C232.373 83.16 232.443 83.58 232.443 84.028ZM237.976 82.502C237.836 82.2313 237.622 82.012 237.332 81.844C237.052 81.6667 236.73 81.578 236.366 81.578C236.198 81.578 236.03 81.5967 235.862 81.634C235.694 81.6713 235.545 81.732 235.414 81.816C235.284 81.9 235.176 82.0073 235.092 82.138C235.018 82.2687 234.98 82.4227 234.98 82.6C234.98 82.908 235.106 83.146 235.358 83.314C235.61 83.4727 236.007 83.608 236.548 83.72C237.323 83.8787 237.892 84.112 238.256 84.42C238.63 84.7187 238.816 85.1247 238.816 85.638C238.816 86.0113 238.742 86.3287 238.592 86.59C238.452 86.842 238.266 87.052 238.032 87.22C237.799 87.3787 237.533 87.4907 237.234 87.556C236.945 87.6307 236.651 87.668 236.352 87.668C235.858 87.668 235.377 87.5653 234.91 87.36C234.444 87.1547 234.061 86.8327 233.762 86.394L234.518 85.834C234.686 86.1233 234.934 86.366 235.26 86.562C235.587 86.758 235.946 86.856 236.338 86.856C236.544 86.856 236.74 86.8373 236.926 86.8C237.113 86.7627 237.276 86.6973 237.416 86.604C237.556 86.5107 237.668 86.394 237.752 86.254C237.836 86.1047 237.878 85.9227 237.878 85.708C237.878 85.3627 237.71 85.106 237.374 84.938C237.048 84.7607 236.572 84.5973 235.946 84.448C235.75 84.4013 235.54 84.3453 235.316 84.28C235.102 84.2053 234.901 84.1027 234.714 83.972C234.528 83.832 234.374 83.6593 234.252 83.454C234.131 83.2487 234.07 82.992 234.07 82.684C234.07 82.348 234.136 82.0633 234.266 81.83C234.397 81.5873 234.57 81.3913 234.784 81.242C235.008 81.0833 235.26 80.9667 235.54 80.892C235.82 80.8173 236.11 80.78 236.408 80.78C236.866 80.78 237.309 80.8827 237.738 81.088C238.168 81.2933 238.49 81.5827 238.704 81.956L237.976 82.502Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1619-inside-7_1593_3270",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.246 107.5H343.246V155.5H116.246V107.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.246 107.5H343.246V155.5H116.246V107.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.246 154.5H116.246V156.5H343.246V154.5Z",
    fill: "#EFEFF0",
    mask: "url(#path-1619-inside-7_1593_3270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.864 127.184C136.649 126.885 136.374 126.647 136.038 126.47C135.702 126.283 135.296 126.19 134.82 126.19C134.577 126.19 134.33 126.227 134.078 126.302C133.826 126.377 133.597 126.493 133.392 126.652C133.187 126.801 133.019 126.993 132.888 127.226C132.767 127.459 132.706 127.735 132.706 128.052C132.706 128.369 132.767 128.631 132.888 128.836C133.009 129.041 133.168 129.219 133.364 129.368C133.569 129.508 133.798 129.625 134.05 129.718C134.311 129.811 134.582 129.905 134.862 129.998C135.207 130.11 135.553 130.231 135.898 130.362C136.253 130.493 136.57 130.665 136.85 130.88C137.13 131.085 137.359 131.351 137.536 131.678C137.713 131.995 137.802 132.401 137.802 132.896C137.802 133.391 137.704 133.82 137.508 134.184C137.321 134.539 137.074 134.833 136.766 135.066C136.467 135.299 136.122 135.472 135.73 135.584C135.347 135.696 134.96 135.752 134.568 135.752C134.269 135.752 133.971 135.719 133.672 135.654C133.373 135.598 133.089 135.509 132.818 135.388C132.547 135.267 132.295 135.113 132.062 134.926C131.829 134.739 131.623 134.525 131.446 134.282L132.314 133.638C132.529 133.993 132.827 134.291 133.21 134.534C133.602 134.767 134.059 134.884 134.582 134.884C134.834 134.884 135.091 134.847 135.352 134.772C135.613 134.688 135.847 134.567 136.052 134.408C136.267 134.24 136.439 134.039 136.57 133.806C136.71 133.563 136.78 133.283 136.78 132.966C136.78 132.621 136.71 132.336 136.57 132.112C136.439 131.879 136.262 131.687 136.038 131.538C135.814 131.379 135.557 131.249 135.268 131.146C134.979 131.043 134.675 130.941 134.358 130.838C134.031 130.735 133.709 130.619 133.392 130.488C133.075 130.357 132.79 130.189 132.538 129.984C132.286 129.769 132.081 129.508 131.922 129.2C131.773 128.892 131.698 128.514 131.698 128.066C131.698 127.59 131.791 127.179 131.978 126.834C132.174 126.489 132.426 126.204 132.734 125.98C133.042 125.756 133.383 125.593 133.756 125.49C134.129 125.387 134.498 125.336 134.862 125.336C135.534 125.336 136.108 125.457 136.584 125.7C137.06 125.933 137.419 126.213 137.662 126.54L136.864 127.184ZM144.906 131.72C144.878 131.104 144.678 130.595 144.304 130.194C143.94 129.783 143.418 129.578 142.736 129.578C142.419 129.578 142.125 129.639 141.854 129.76C141.584 129.872 141.346 130.031 141.14 130.236C140.935 130.432 140.772 130.661 140.65 130.922C140.529 131.174 140.459 131.44 140.44 131.72H144.906ZM145.872 132.028C145.872 132.093 145.872 132.163 145.872 132.238C145.872 132.313 145.868 132.392 145.858 132.476H140.426C140.436 132.803 140.501 133.111 140.622 133.4C140.744 133.689 140.912 133.941 141.126 134.156C141.341 134.371 141.593 134.543 141.882 134.674C142.172 134.795 142.484 134.856 142.82 134.856C143.315 134.856 143.74 134.744 144.094 134.52C144.458 134.287 144.734 134.021 144.92 133.722L145.634 134.282C145.242 134.777 144.808 135.131 144.332 135.346C143.866 135.561 143.362 135.668 142.82 135.668C142.335 135.668 141.882 135.584 141.462 135.416C141.052 135.239 140.697 134.996 140.398 134.688C140.1 134.38 139.862 134.016 139.684 133.596C139.516 133.176 139.432 132.719 139.432 132.224C139.432 131.729 139.516 131.272 139.684 130.852C139.852 130.432 140.086 130.068 140.384 129.76C140.683 129.452 141.033 129.214 141.434 129.046C141.836 128.869 142.27 128.78 142.736 128.78C143.25 128.78 143.702 128.869 144.094 129.046C144.486 129.214 144.813 129.447 145.074 129.746C145.336 130.035 145.532 130.376 145.662 130.768C145.802 131.16 145.872 131.58 145.872 132.028ZM148.872 138.86H147.92V128.948H148.872V130.082H148.914C149.185 129.653 149.544 129.331 149.992 129.116C150.449 128.892 150.911 128.78 151.378 128.78C151.891 128.78 152.353 128.869 152.764 129.046C153.184 129.223 153.539 129.466 153.828 129.774C154.127 130.082 154.355 130.446 154.514 130.866C154.682 131.286 154.766 131.739 154.766 132.224C154.766 132.709 154.682 133.162 154.514 133.582C154.355 134.002 154.127 134.366 153.828 134.674C153.539 134.982 153.184 135.225 152.764 135.402C152.353 135.579 151.891 135.668 151.378 135.668C150.911 135.668 150.449 135.561 149.992 135.346C149.544 135.122 149.185 134.805 148.914 134.394H148.872V138.86ZM153.758 132.224C153.758 131.86 153.702 131.519 153.59 131.202C153.478 130.875 153.315 130.595 153.1 130.362C152.895 130.119 152.638 129.928 152.33 129.788C152.022 129.648 151.672 129.578 151.28 129.578C150.916 129.578 150.58 129.648 150.272 129.788C149.964 129.919 149.698 130.105 149.474 130.348C149.25 130.581 149.073 130.861 148.942 131.188C148.821 131.505 148.76 131.851 148.76 132.224C148.76 132.597 148.821 132.947 148.942 133.274C149.073 133.591 149.25 133.867 149.474 134.1C149.698 134.333 149.964 134.52 150.272 134.66C150.58 134.791 150.916 134.856 151.28 134.856C151.672 134.856 152.022 134.791 152.33 134.66C152.638 134.52 152.895 134.333 153.1 134.1C153.315 133.857 153.478 133.577 153.59 133.26C153.702 132.933 153.758 132.588 153.758 132.224ZM159.761 129.746H157.913V133.568C157.913 133.811 157.936 134.011 157.983 134.17C158.03 134.329 158.095 134.455 158.179 134.548C158.272 134.632 158.38 134.693 158.501 134.73C158.622 134.758 158.753 134.772 158.893 134.772C159.024 134.772 159.159 134.753 159.299 134.716C159.448 134.679 159.588 134.627 159.719 134.562L159.761 135.388C159.593 135.453 159.416 135.5 159.229 135.528C159.052 135.565 158.856 135.584 158.641 135.584C158.464 135.584 158.277 135.561 158.081 135.514C157.885 135.467 157.703 135.379 157.535 135.248C157.367 135.117 157.227 134.94 157.115 134.716C157.012 134.492 156.961 134.198 156.961 133.834V129.746H155.603V128.948H156.961V127.1H157.913V128.948H159.761V129.746ZM166.248 131.72C166.22 131.104 166.02 130.595 165.646 130.194C165.282 129.783 164.76 129.578 164.078 129.578C163.761 129.578 163.467 129.639 163.196 129.76C162.926 129.872 162.688 130.031 162.482 130.236C162.277 130.432 162.114 130.661 161.992 130.922C161.871 131.174 161.801 131.44 161.782 131.72H166.248ZM167.214 132.028C167.214 132.093 167.214 132.163 167.214 132.238C167.214 132.313 167.21 132.392 167.2 132.476H161.768C161.778 132.803 161.843 133.111 161.964 133.4C162.086 133.689 162.254 133.941 162.468 134.156C162.683 134.371 162.935 134.543 163.224 134.674C163.514 134.795 163.826 134.856 164.162 134.856C164.657 134.856 165.082 134.744 165.436 134.52C165.8 134.287 166.076 134.021 166.262 133.722L166.976 134.282C166.584 134.777 166.15 135.131 165.674 135.346C165.208 135.561 164.704 135.668 164.162 135.668C163.677 135.668 163.224 135.584 162.804 135.416C162.394 135.239 162.039 134.996 161.74 134.688C161.442 134.38 161.204 134.016 161.026 133.596C160.858 133.176 160.774 132.719 160.774 132.224C160.774 131.729 160.858 131.272 161.026 130.852C161.194 130.432 161.428 130.068 161.726 129.76C162.025 129.452 162.375 129.214 162.776 129.046C163.178 128.869 163.612 128.78 164.078 128.78C164.592 128.78 165.044 128.869 165.436 129.046C165.828 129.214 166.155 129.447 166.416 129.746C166.678 130.035 166.874 130.376 167.004 130.768C167.144 131.16 167.214 131.58 167.214 132.028ZM170.2 130.068C170.387 129.685 170.671 129.377 171.054 129.144C171.446 128.901 171.88 128.78 172.356 128.78C172.533 128.78 172.715 128.799 172.902 128.836C173.098 128.873 173.285 128.948 173.462 129.06C173.649 129.163 173.817 129.303 173.966 129.48C174.125 129.657 174.26 129.886 174.372 130.166C174.596 129.718 174.899 129.377 175.282 129.144C175.674 128.901 176.136 128.78 176.668 128.78C177.499 128.78 178.119 129.027 178.53 129.522C178.95 130.017 179.16 130.67 179.16 131.482V135.5H178.208V131.874C178.208 131.183 178.077 130.628 177.816 130.208C177.564 129.788 177.13 129.578 176.514 129.578C176.169 129.578 175.875 129.648 175.632 129.788C175.399 129.928 175.207 130.115 175.058 130.348C174.918 130.572 174.815 130.829 174.75 131.118C174.685 131.407 174.652 131.706 174.652 132.014V135.5H173.7V131.678C173.7 131.361 173.677 131.071 173.63 130.81C173.583 130.549 173.499 130.329 173.378 130.152C173.266 129.965 173.107 129.825 172.902 129.732C172.697 129.629 172.435 129.578 172.118 129.578C171.894 129.578 171.665 129.629 171.432 129.732C171.208 129.835 171.003 129.993 170.816 130.208C170.639 130.413 170.494 130.679 170.382 131.006C170.27 131.323 170.214 131.701 170.214 132.14V135.5H169.262V130.39C169.262 130.213 169.257 129.984 169.248 129.704C169.239 129.424 169.225 129.172 169.206 128.948H170.116C170.135 129.125 170.149 129.321 170.158 129.536C170.167 129.751 170.172 129.928 170.172 130.068H170.2ZM182.601 134.394V135.5H181.649V124.916H182.601V130.082H182.629C182.909 129.653 183.273 129.331 183.721 129.116C184.169 128.892 184.631 128.78 185.107 128.78C185.621 128.78 186.083 128.869 186.493 129.046C186.913 129.223 187.268 129.466 187.557 129.774C187.856 130.082 188.085 130.446 188.243 130.866C188.411 131.286 188.495 131.739 188.495 132.224C188.495 132.709 188.411 133.162 188.243 133.582C188.085 134.002 187.856 134.366 187.557 134.674C187.268 134.982 186.913 135.225 186.493 135.402C186.083 135.579 185.621 135.668 185.107 135.668C184.631 135.668 184.169 135.561 183.721 135.346C183.273 135.131 182.909 134.814 182.629 134.394H182.601ZM187.487 132.224C187.487 131.86 187.431 131.519 187.319 131.202C187.207 130.875 187.044 130.595 186.829 130.362C186.624 130.119 186.367 129.928 186.059 129.788C185.751 129.648 185.401 129.578 185.009 129.578C184.645 129.578 184.309 129.648 184.001 129.788C183.693 129.919 183.427 130.105 183.203 130.348C182.979 130.581 182.802 130.861 182.671 131.188C182.55 131.505 182.489 131.851 182.489 132.224C182.489 132.597 182.55 132.947 182.671 133.274C182.802 133.591 182.979 133.867 183.203 134.1C183.427 134.333 183.693 134.52 184.001 134.66C184.309 134.791 184.645 134.856 185.009 134.856C185.401 134.856 185.751 134.791 186.059 134.66C186.367 134.52 186.624 134.333 186.829 134.1C187.044 133.857 187.207 133.577 187.319 133.26C187.431 132.933 187.487 132.588 187.487 132.224ZM195.533 131.72C195.505 131.104 195.305 130.595 194.931 130.194C194.567 129.783 194.045 129.578 193.363 129.578C193.046 129.578 192.752 129.639 192.481 129.76C192.211 129.872 191.973 130.031 191.767 130.236C191.562 130.432 191.399 130.661 191.277 130.922C191.156 131.174 191.086 131.44 191.067 131.72H195.533ZM196.499 132.028C196.499 132.093 196.499 132.163 196.499 132.238C196.499 132.313 196.495 132.392 196.485 132.476H191.053C191.063 132.803 191.128 133.111 191.249 133.4C191.371 133.689 191.539 133.941 191.753 134.156C191.968 134.371 192.22 134.543 192.509 134.674C192.799 134.795 193.111 134.856 193.447 134.856C193.942 134.856 194.367 134.744 194.721 134.52C195.085 134.287 195.361 134.021 195.547 133.722L196.261 134.282C195.869 134.777 195.435 135.131 194.959 135.346C194.493 135.561 193.989 135.668 193.447 135.668C192.962 135.668 192.509 135.584 192.089 135.416C191.679 135.239 191.324 134.996 191.025 134.688C190.727 134.38 190.489 134.016 190.311 133.596C190.143 133.176 190.059 132.719 190.059 132.224C190.059 131.729 190.143 131.272 190.311 130.852C190.479 130.432 190.713 130.068 191.011 129.76C191.31 129.452 191.66 129.214 192.061 129.046C192.463 128.869 192.897 128.78 193.363 128.78C193.877 128.78 194.329 128.869 194.721 129.046C195.113 129.214 195.44 129.447 195.701 129.746C195.963 130.035 196.159 130.376 196.289 130.768C196.429 131.16 196.499 131.58 196.499 132.028ZM198.547 130.39C198.547 130.213 198.542 129.984 198.533 129.704C198.524 129.424 198.51 129.172 198.491 128.948H199.401C199.42 129.125 199.434 129.321 199.443 129.536C199.452 129.751 199.457 129.928 199.457 130.068H199.485C199.672 129.685 199.952 129.377 200.325 129.144C200.698 128.901 201.118 128.78 201.585 128.78C201.706 128.78 201.814 128.785 201.907 128.794C202.01 128.803 202.112 128.822 202.215 128.85L202.089 129.746C202.033 129.727 201.94 129.709 201.809 129.69C201.678 129.671 201.548 129.662 201.417 129.662C201.165 129.662 200.922 129.709 200.689 129.802C200.456 129.895 200.25 130.045 200.073 130.25C199.905 130.446 199.765 130.703 199.653 131.02C199.55 131.328 199.499 131.701 199.499 132.14V135.5H198.547V130.39ZM208.03 130.068C208.217 129.685 208.501 129.377 208.884 129.144C209.276 128.901 209.71 128.78 210.186 128.78C210.363 128.78 210.545 128.799 210.732 128.836C210.928 128.873 211.115 128.948 211.292 129.06C211.479 129.163 211.647 129.303 211.796 129.48C211.955 129.657 212.09 129.886 212.202 130.166C212.426 129.718 212.729 129.377 213.112 129.144C213.504 128.901 213.966 128.78 214.498 128.78C215.329 128.78 215.949 129.027 216.36 129.522C216.78 130.017 216.99 130.67 216.99 131.482V135.5H216.038V131.874C216.038 131.183 215.907 130.628 215.646 130.208C215.394 129.788 214.96 129.578 214.344 129.578C213.999 129.578 213.705 129.648 213.462 129.788C213.229 129.928 213.037 130.115 212.888 130.348C212.748 130.572 212.645 130.829 212.58 131.118C212.515 131.407 212.482 131.706 212.482 132.014V135.5H211.53V131.678C211.53 131.361 211.507 131.071 211.46 130.81C211.413 130.549 211.329 130.329 211.208 130.152C211.096 129.965 210.937 129.825 210.732 129.732C210.527 129.629 210.265 129.578 209.948 129.578C209.724 129.578 209.495 129.629 209.262 129.732C209.038 129.835 208.833 129.993 208.646 130.208C208.469 130.413 208.324 130.679 208.212 131.006C208.1 131.323 208.044 131.701 208.044 132.14V135.5H207.092V130.39C207.092 130.213 207.087 129.984 207.078 129.704C207.069 129.424 207.055 129.172 207.036 128.948H207.946C207.965 129.125 207.979 129.321 207.988 129.536C207.997 129.751 208.002 129.928 208.002 130.068H208.03ZM220.417 135.5H219.465V128.948H220.417V135.5ZM220.613 126.428C220.613 126.624 220.543 126.787 220.403 126.918C220.263 127.039 220.109 127.1 219.941 127.1C219.773 127.1 219.619 127.039 219.479 126.918C219.339 126.787 219.269 126.624 219.269 126.428C219.269 126.232 219.339 126.073 219.479 125.952C219.619 125.821 219.773 125.756 219.941 125.756C220.109 125.756 220.263 125.821 220.403 125.952C220.543 126.073 220.613 126.232 220.613 126.428ZM223.931 135.5H222.979V124.916H223.931V135.5ZM231.477 131.72C231.449 131.104 231.248 130.595 230.875 130.194C230.511 129.783 229.988 129.578 229.307 129.578C228.989 129.578 228.695 129.639 228.425 129.76C228.154 129.872 227.916 130.031 227.711 130.236C227.505 130.432 227.342 130.661 227.221 130.922C227.099 131.174 227.029 131.44 227.011 131.72H231.477ZM232.443 132.028C232.443 132.093 232.443 132.163 232.443 132.238C232.443 132.313 232.438 132.392 232.429 132.476H226.997C227.006 132.803 227.071 133.111 227.193 133.4C227.314 133.689 227.482 133.941 227.697 134.156C227.911 134.371 228.163 134.543 228.453 134.674C228.742 134.795 229.055 134.856 229.391 134.856C229.885 134.856 230.31 134.744 230.665 134.52C231.029 134.287 231.304 134.021 231.491 133.722L232.205 134.282C231.813 134.777 231.379 135.131 230.903 135.346C230.436 135.561 229.932 135.668 229.391 135.668C228.905 135.668 228.453 135.584 228.033 135.416C227.622 135.239 227.267 134.996 226.969 134.688C226.67 134.38 226.432 134.016 226.255 133.596C226.087 133.176 226.003 132.719 226.003 132.224C226.003 131.729 226.087 131.272 226.255 130.852C226.423 130.432 226.656 130.068 226.955 129.76C227.253 129.452 227.603 129.214 228.005 129.046C228.406 128.869 228.84 128.78 229.307 128.78C229.82 128.78 230.273 128.869 230.665 129.046C231.057 129.214 231.383 129.447 231.645 129.746C231.906 130.035 232.102 130.376 232.233 130.768C232.373 131.16 232.443 131.58 232.443 132.028ZM237.976 130.502C237.836 130.231 237.622 130.012 237.332 129.844C237.052 129.667 236.73 129.578 236.366 129.578C236.198 129.578 236.03 129.597 235.862 129.634C235.694 129.671 235.545 129.732 235.414 129.816C235.284 129.9 235.176 130.007 235.092 130.138C235.018 130.269 234.98 130.423 234.98 130.6C234.98 130.908 235.106 131.146 235.358 131.314C235.61 131.473 236.007 131.608 236.548 131.72C237.323 131.879 237.892 132.112 238.256 132.42C238.63 132.719 238.816 133.125 238.816 133.638C238.816 134.011 238.742 134.329 238.592 134.59C238.452 134.842 238.266 135.052 238.032 135.22C237.799 135.379 237.533 135.491 237.234 135.556C236.945 135.631 236.651 135.668 236.352 135.668C235.858 135.668 235.377 135.565 234.91 135.36C234.444 135.155 234.061 134.833 233.762 134.394L234.518 133.834C234.686 134.123 234.934 134.366 235.26 134.562C235.587 134.758 235.946 134.856 236.338 134.856C236.544 134.856 236.74 134.837 236.926 134.8C237.113 134.763 237.276 134.697 237.416 134.604C237.556 134.511 237.668 134.394 237.752 134.254C237.836 134.105 237.878 133.923 237.878 133.708C237.878 133.363 237.71 133.106 237.374 132.938C237.048 132.761 236.572 132.597 235.946 132.448C235.75 132.401 235.54 132.345 235.316 132.28C235.102 132.205 234.901 132.103 234.714 131.972C234.528 131.832 234.374 131.659 234.252 131.454C234.131 131.249 234.07 130.992 234.07 130.684C234.07 130.348 234.136 130.063 234.266 129.83C234.397 129.587 234.57 129.391 234.784 129.242C235.008 129.083 235.26 128.967 235.54 128.892C235.82 128.817 236.11 128.78 236.408 128.78C236.866 128.78 237.309 128.883 237.738 129.088C238.168 129.293 238.49 129.583 238.704 129.956L237.976 130.502Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1622-inside-8_1593_3270",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.246 155.5H343.246V203.5H116.246V155.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.246 155.5H343.246V203.5H116.246V155.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.246 202.5H116.246V204.5H343.246V202.5Z",
    fill: "#EFEFF0",
    mask: "url(#path-1622-inside-8_1593_3270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.864 175.184C136.649 174.885 136.374 174.647 136.038 174.47C135.702 174.283 135.296 174.19 134.82 174.19C134.577 174.19 134.33 174.227 134.078 174.302C133.826 174.377 133.597 174.493 133.392 174.652C133.187 174.801 133.019 174.993 132.888 175.226C132.767 175.459 132.706 175.735 132.706 176.052C132.706 176.369 132.767 176.631 132.888 176.836C133.009 177.041 133.168 177.219 133.364 177.368C133.569 177.508 133.798 177.625 134.05 177.718C134.311 177.811 134.582 177.905 134.862 177.998C135.207 178.11 135.553 178.231 135.898 178.362C136.253 178.493 136.57 178.665 136.85 178.88C137.13 179.085 137.359 179.351 137.536 179.678C137.713 179.995 137.802 180.401 137.802 180.896C137.802 181.391 137.704 181.82 137.508 182.184C137.321 182.539 137.074 182.833 136.766 183.066C136.467 183.299 136.122 183.472 135.73 183.584C135.347 183.696 134.96 183.752 134.568 183.752C134.269 183.752 133.971 183.719 133.672 183.654C133.373 183.598 133.089 183.509 132.818 183.388C132.547 183.267 132.295 183.113 132.062 182.926C131.829 182.739 131.623 182.525 131.446 182.282L132.314 181.638C132.529 181.993 132.827 182.291 133.21 182.534C133.602 182.767 134.059 182.884 134.582 182.884C134.834 182.884 135.091 182.847 135.352 182.772C135.613 182.688 135.847 182.567 136.052 182.408C136.267 182.24 136.439 182.039 136.57 181.806C136.71 181.563 136.78 181.283 136.78 180.966C136.78 180.621 136.71 180.336 136.57 180.112C136.439 179.879 136.262 179.687 136.038 179.538C135.814 179.379 135.557 179.249 135.268 179.146C134.979 179.043 134.675 178.941 134.358 178.838C134.031 178.735 133.709 178.619 133.392 178.488C133.075 178.357 132.79 178.189 132.538 177.984C132.286 177.769 132.081 177.508 131.922 177.2C131.773 176.892 131.698 176.514 131.698 176.066C131.698 175.59 131.791 175.179 131.978 174.834C132.174 174.489 132.426 174.204 132.734 173.98C133.042 173.756 133.383 173.593 133.756 173.49C134.129 173.387 134.498 173.336 134.862 173.336C135.534 173.336 136.108 173.457 136.584 173.7C137.06 173.933 137.419 174.213 137.662 174.54L136.864 175.184ZM144.906 179.72C144.878 179.104 144.678 178.595 144.304 178.194C143.94 177.783 143.418 177.578 142.736 177.578C142.419 177.578 142.125 177.639 141.854 177.76C141.584 177.872 141.346 178.031 141.14 178.236C140.935 178.432 140.772 178.661 140.65 178.922C140.529 179.174 140.459 179.44 140.44 179.72H144.906ZM145.872 180.028C145.872 180.093 145.872 180.163 145.872 180.238C145.872 180.313 145.868 180.392 145.858 180.476H140.426C140.436 180.803 140.501 181.111 140.622 181.4C140.744 181.689 140.912 181.941 141.126 182.156C141.341 182.371 141.593 182.543 141.882 182.674C142.172 182.795 142.484 182.856 142.82 182.856C143.315 182.856 143.74 182.744 144.094 182.52C144.458 182.287 144.734 182.021 144.92 181.722L145.634 182.282C145.242 182.777 144.808 183.131 144.332 183.346C143.866 183.561 143.362 183.668 142.82 183.668C142.335 183.668 141.882 183.584 141.462 183.416C141.052 183.239 140.697 182.996 140.398 182.688C140.1 182.38 139.862 182.016 139.684 181.596C139.516 181.176 139.432 180.719 139.432 180.224C139.432 179.729 139.516 179.272 139.684 178.852C139.852 178.432 140.086 178.068 140.384 177.76C140.683 177.452 141.033 177.214 141.434 177.046C141.836 176.869 142.27 176.78 142.736 176.78C143.25 176.78 143.702 176.869 144.094 177.046C144.486 177.214 144.813 177.447 145.074 177.746C145.336 178.035 145.532 178.376 145.662 178.768C145.802 179.16 145.872 179.58 145.872 180.028ZM148.872 186.86H147.92V176.948H148.872V178.082H148.914C149.185 177.653 149.544 177.331 149.992 177.116C150.449 176.892 150.911 176.78 151.378 176.78C151.891 176.78 152.353 176.869 152.764 177.046C153.184 177.223 153.539 177.466 153.828 177.774C154.127 178.082 154.355 178.446 154.514 178.866C154.682 179.286 154.766 179.739 154.766 180.224C154.766 180.709 154.682 181.162 154.514 181.582C154.355 182.002 154.127 182.366 153.828 182.674C153.539 182.982 153.184 183.225 152.764 183.402C152.353 183.579 151.891 183.668 151.378 183.668C150.911 183.668 150.449 183.561 149.992 183.346C149.544 183.122 149.185 182.805 148.914 182.394H148.872V186.86ZM153.758 180.224C153.758 179.86 153.702 179.519 153.59 179.202C153.478 178.875 153.315 178.595 153.1 178.362C152.895 178.119 152.638 177.928 152.33 177.788C152.022 177.648 151.672 177.578 151.28 177.578C150.916 177.578 150.58 177.648 150.272 177.788C149.964 177.919 149.698 178.105 149.474 178.348C149.25 178.581 149.073 178.861 148.942 179.188C148.821 179.505 148.76 179.851 148.76 180.224C148.76 180.597 148.821 180.947 148.942 181.274C149.073 181.591 149.25 181.867 149.474 182.1C149.698 182.333 149.964 182.52 150.272 182.66C150.58 182.791 150.916 182.856 151.28 182.856C151.672 182.856 152.022 182.791 152.33 182.66C152.638 182.52 152.895 182.333 153.1 182.1C153.315 181.857 153.478 181.577 153.59 181.26C153.702 180.933 153.758 180.588 153.758 180.224ZM159.761 177.746H157.913V181.568C157.913 181.811 157.936 182.011 157.983 182.17C158.03 182.329 158.095 182.455 158.179 182.548C158.272 182.632 158.38 182.693 158.501 182.73C158.622 182.758 158.753 182.772 158.893 182.772C159.024 182.772 159.159 182.753 159.299 182.716C159.448 182.679 159.588 182.627 159.719 182.562L159.761 183.388C159.593 183.453 159.416 183.5 159.229 183.528C159.052 183.565 158.856 183.584 158.641 183.584C158.464 183.584 158.277 183.561 158.081 183.514C157.885 183.467 157.703 183.379 157.535 183.248C157.367 183.117 157.227 182.94 157.115 182.716C157.012 182.492 156.961 182.198 156.961 181.834V177.746H155.603V176.948H156.961V175.1H157.913V176.948H159.761V177.746ZM166.248 179.72C166.22 179.104 166.02 178.595 165.646 178.194C165.282 177.783 164.76 177.578 164.078 177.578C163.761 177.578 163.467 177.639 163.196 177.76C162.926 177.872 162.688 178.031 162.482 178.236C162.277 178.432 162.114 178.661 161.992 178.922C161.871 179.174 161.801 179.44 161.782 179.72H166.248ZM167.214 180.028C167.214 180.093 167.214 180.163 167.214 180.238C167.214 180.313 167.21 180.392 167.2 180.476H161.768C161.778 180.803 161.843 181.111 161.964 181.4C162.086 181.689 162.254 181.941 162.468 182.156C162.683 182.371 162.935 182.543 163.224 182.674C163.514 182.795 163.826 182.856 164.162 182.856C164.657 182.856 165.082 182.744 165.436 182.52C165.8 182.287 166.076 182.021 166.262 181.722L166.976 182.282C166.584 182.777 166.15 183.131 165.674 183.346C165.208 183.561 164.704 183.668 164.162 183.668C163.677 183.668 163.224 183.584 162.804 183.416C162.394 183.239 162.039 182.996 161.74 182.688C161.442 182.38 161.204 182.016 161.026 181.596C160.858 181.176 160.774 180.719 160.774 180.224C160.774 179.729 160.858 179.272 161.026 178.852C161.194 178.432 161.428 178.068 161.726 177.76C162.025 177.452 162.375 177.214 162.776 177.046C163.178 176.869 163.612 176.78 164.078 176.78C164.592 176.78 165.044 176.869 165.436 177.046C165.828 177.214 166.155 177.447 166.416 177.746C166.678 178.035 166.874 178.376 167.004 178.768C167.144 179.16 167.214 179.58 167.214 180.028ZM170.2 178.068C170.387 177.685 170.671 177.377 171.054 177.144C171.446 176.901 171.88 176.78 172.356 176.78C172.533 176.78 172.715 176.799 172.902 176.836C173.098 176.873 173.285 176.948 173.462 177.06C173.649 177.163 173.817 177.303 173.966 177.48C174.125 177.657 174.26 177.886 174.372 178.166C174.596 177.718 174.899 177.377 175.282 177.144C175.674 176.901 176.136 176.78 176.668 176.78C177.499 176.78 178.119 177.027 178.53 177.522C178.95 178.017 179.16 178.67 179.16 179.482V183.5H178.208V179.874C178.208 179.183 178.077 178.628 177.816 178.208C177.564 177.788 177.13 177.578 176.514 177.578C176.169 177.578 175.875 177.648 175.632 177.788C175.399 177.928 175.207 178.115 175.058 178.348C174.918 178.572 174.815 178.829 174.75 179.118C174.685 179.407 174.652 179.706 174.652 180.014V183.5H173.7V179.678C173.7 179.361 173.677 179.071 173.63 178.81C173.583 178.549 173.499 178.329 173.378 178.152C173.266 177.965 173.107 177.825 172.902 177.732C172.697 177.629 172.435 177.578 172.118 177.578C171.894 177.578 171.665 177.629 171.432 177.732C171.208 177.835 171.003 177.993 170.816 178.208C170.639 178.413 170.494 178.679 170.382 179.006C170.27 179.323 170.214 179.701 170.214 180.14V183.5H169.262V178.39C169.262 178.213 169.257 177.984 169.248 177.704C169.239 177.424 169.225 177.172 169.206 176.948H170.116C170.135 177.125 170.149 177.321 170.158 177.536C170.167 177.751 170.172 177.928 170.172 178.068H170.2ZM182.601 182.394V183.5H181.649V172.916H182.601V178.082H182.629C182.909 177.653 183.273 177.331 183.721 177.116C184.169 176.892 184.631 176.78 185.107 176.78C185.621 176.78 186.083 176.869 186.493 177.046C186.913 177.223 187.268 177.466 187.557 177.774C187.856 178.082 188.085 178.446 188.243 178.866C188.411 179.286 188.495 179.739 188.495 180.224C188.495 180.709 188.411 181.162 188.243 181.582C188.085 182.002 187.856 182.366 187.557 182.674C187.268 182.982 186.913 183.225 186.493 183.402C186.083 183.579 185.621 183.668 185.107 183.668C184.631 183.668 184.169 183.561 183.721 183.346C183.273 183.131 182.909 182.814 182.629 182.394H182.601ZM187.487 180.224C187.487 179.86 187.431 179.519 187.319 179.202C187.207 178.875 187.044 178.595 186.829 178.362C186.624 178.119 186.367 177.928 186.059 177.788C185.751 177.648 185.401 177.578 185.009 177.578C184.645 177.578 184.309 177.648 184.001 177.788C183.693 177.919 183.427 178.105 183.203 178.348C182.979 178.581 182.802 178.861 182.671 179.188C182.55 179.505 182.489 179.851 182.489 180.224C182.489 180.597 182.55 180.947 182.671 181.274C182.802 181.591 182.979 181.867 183.203 182.1C183.427 182.333 183.693 182.52 184.001 182.66C184.309 182.791 184.645 182.856 185.009 182.856C185.401 182.856 185.751 182.791 186.059 182.66C186.367 182.52 186.624 182.333 186.829 182.1C187.044 181.857 187.207 181.577 187.319 181.26C187.431 180.933 187.487 180.588 187.487 180.224ZM195.533 179.72C195.505 179.104 195.305 178.595 194.931 178.194C194.567 177.783 194.045 177.578 193.363 177.578C193.046 177.578 192.752 177.639 192.481 177.76C192.211 177.872 191.973 178.031 191.767 178.236C191.562 178.432 191.399 178.661 191.277 178.922C191.156 179.174 191.086 179.44 191.067 179.72H195.533ZM196.499 180.028C196.499 180.093 196.499 180.163 196.499 180.238C196.499 180.313 196.495 180.392 196.485 180.476H191.053C191.063 180.803 191.128 181.111 191.249 181.4C191.371 181.689 191.539 181.941 191.753 182.156C191.968 182.371 192.22 182.543 192.509 182.674C192.799 182.795 193.111 182.856 193.447 182.856C193.942 182.856 194.367 182.744 194.721 182.52C195.085 182.287 195.361 182.021 195.547 181.722L196.261 182.282C195.869 182.777 195.435 183.131 194.959 183.346C194.493 183.561 193.989 183.668 193.447 183.668C192.962 183.668 192.509 183.584 192.089 183.416C191.679 183.239 191.324 182.996 191.025 182.688C190.727 182.38 190.489 182.016 190.311 181.596C190.143 181.176 190.059 180.719 190.059 180.224C190.059 179.729 190.143 179.272 190.311 178.852C190.479 178.432 190.713 178.068 191.011 177.76C191.31 177.452 191.66 177.214 192.061 177.046C192.463 176.869 192.897 176.78 193.363 176.78C193.877 176.78 194.329 176.869 194.721 177.046C195.113 177.214 195.44 177.447 195.701 177.746C195.963 178.035 196.159 178.376 196.289 178.768C196.429 179.16 196.499 179.58 196.499 180.028ZM198.547 178.39C198.547 178.213 198.542 177.984 198.533 177.704C198.524 177.424 198.51 177.172 198.491 176.948H199.401C199.42 177.125 199.434 177.321 199.443 177.536C199.452 177.751 199.457 177.928 199.457 178.068H199.485C199.672 177.685 199.952 177.377 200.325 177.144C200.698 176.901 201.118 176.78 201.585 176.78C201.706 176.78 201.814 176.785 201.907 176.794C202.01 176.803 202.112 176.822 202.215 176.85L202.089 177.746C202.033 177.727 201.94 177.709 201.809 177.69C201.678 177.671 201.548 177.662 201.417 177.662C201.165 177.662 200.922 177.709 200.689 177.802C200.456 177.895 200.25 178.045 200.073 178.25C199.905 178.446 199.765 178.703 199.653 179.02C199.55 179.328 199.499 179.701 199.499 180.14V183.5H198.547V178.39ZM208.03 178.068C208.217 177.685 208.501 177.377 208.884 177.144C209.276 176.901 209.71 176.78 210.186 176.78C210.363 176.78 210.545 176.799 210.732 176.836C210.928 176.873 211.115 176.948 211.292 177.06C211.479 177.163 211.647 177.303 211.796 177.48C211.955 177.657 212.09 177.886 212.202 178.166C212.426 177.718 212.729 177.377 213.112 177.144C213.504 176.901 213.966 176.78 214.498 176.78C215.329 176.78 215.949 177.027 216.36 177.522C216.78 178.017 216.99 178.67 216.99 179.482V183.5H216.038V179.874C216.038 179.183 215.907 178.628 215.646 178.208C215.394 177.788 214.96 177.578 214.344 177.578C213.999 177.578 213.705 177.648 213.462 177.788C213.229 177.928 213.037 178.115 212.888 178.348C212.748 178.572 212.645 178.829 212.58 179.118C212.515 179.407 212.482 179.706 212.482 180.014V183.5H211.53V179.678C211.53 179.361 211.507 179.071 211.46 178.81C211.413 178.549 211.329 178.329 211.208 178.152C211.096 177.965 210.937 177.825 210.732 177.732C210.527 177.629 210.265 177.578 209.948 177.578C209.724 177.578 209.495 177.629 209.262 177.732C209.038 177.835 208.833 177.993 208.646 178.208C208.469 178.413 208.324 178.679 208.212 179.006C208.1 179.323 208.044 179.701 208.044 180.14V183.5H207.092V178.39C207.092 178.213 207.087 177.984 207.078 177.704C207.069 177.424 207.055 177.172 207.036 176.948H207.946C207.965 177.125 207.979 177.321 207.988 177.536C207.997 177.751 208.002 177.928 208.002 178.068H208.03ZM220.417 183.5H219.465V176.948H220.417V183.5ZM220.613 174.428C220.613 174.624 220.543 174.787 220.403 174.918C220.263 175.039 220.109 175.1 219.941 175.1C219.773 175.1 219.619 175.039 219.479 174.918C219.339 174.787 219.269 174.624 219.269 174.428C219.269 174.232 219.339 174.073 219.479 173.952C219.619 173.821 219.773 173.756 219.941 173.756C220.109 173.756 220.263 173.821 220.403 173.952C220.543 174.073 220.613 174.232 220.613 174.428ZM223.931 183.5H222.979V172.916H223.931V183.5ZM231.477 179.72C231.449 179.104 231.248 178.595 230.875 178.194C230.511 177.783 229.988 177.578 229.307 177.578C228.989 177.578 228.695 177.639 228.425 177.76C228.154 177.872 227.916 178.031 227.711 178.236C227.505 178.432 227.342 178.661 227.221 178.922C227.099 179.174 227.029 179.44 227.011 179.72H231.477ZM232.443 180.028C232.443 180.093 232.443 180.163 232.443 180.238C232.443 180.313 232.438 180.392 232.429 180.476H226.997C227.006 180.803 227.071 181.111 227.193 181.4C227.314 181.689 227.482 181.941 227.697 182.156C227.911 182.371 228.163 182.543 228.453 182.674C228.742 182.795 229.055 182.856 229.391 182.856C229.885 182.856 230.31 182.744 230.665 182.52C231.029 182.287 231.304 182.021 231.491 181.722L232.205 182.282C231.813 182.777 231.379 183.131 230.903 183.346C230.436 183.561 229.932 183.668 229.391 183.668C228.905 183.668 228.453 183.584 228.033 183.416C227.622 183.239 227.267 182.996 226.969 182.688C226.67 182.38 226.432 182.016 226.255 181.596C226.087 181.176 226.003 180.719 226.003 180.224C226.003 179.729 226.087 179.272 226.255 178.852C226.423 178.432 226.656 178.068 226.955 177.76C227.253 177.452 227.603 177.214 228.005 177.046C228.406 176.869 228.84 176.78 229.307 176.78C229.82 176.78 230.273 176.869 230.665 177.046C231.057 177.214 231.383 177.447 231.645 177.746C231.906 178.035 232.102 178.376 232.233 178.768C232.373 179.16 232.443 179.58 232.443 180.028ZM237.976 178.502C237.836 178.231 237.622 178.012 237.332 177.844C237.052 177.667 236.73 177.578 236.366 177.578C236.198 177.578 236.03 177.597 235.862 177.634C235.694 177.671 235.545 177.732 235.414 177.816C235.284 177.9 235.176 178.007 235.092 178.138C235.018 178.269 234.98 178.423 234.98 178.6C234.98 178.908 235.106 179.146 235.358 179.314C235.61 179.473 236.007 179.608 236.548 179.72C237.323 179.879 237.892 180.112 238.256 180.42C238.63 180.719 238.816 181.125 238.816 181.638C238.816 182.011 238.742 182.329 238.592 182.59C238.452 182.842 238.266 183.052 238.032 183.22C237.799 183.379 237.533 183.491 237.234 183.556C236.945 183.631 236.651 183.668 236.352 183.668C235.858 183.668 235.377 183.565 234.91 183.36C234.444 183.155 234.061 182.833 233.762 182.394L234.518 181.834C234.686 182.123 234.934 182.366 235.26 182.562C235.587 182.758 235.946 182.856 236.338 182.856C236.544 182.856 236.74 182.837 236.926 182.8C237.113 182.763 237.276 182.697 237.416 182.604C237.556 182.511 237.668 182.394 237.752 182.254C237.836 182.105 237.878 181.923 237.878 181.708C237.878 181.363 237.71 181.106 237.374 180.938C237.048 180.761 236.572 180.597 235.946 180.448C235.75 180.401 235.54 180.345 235.316 180.28C235.102 180.205 234.901 180.103 234.714 179.972C234.528 179.832 234.374 179.659 234.252 179.454C234.131 179.249 234.07 178.992 234.07 178.684C234.07 178.348 234.136 178.063 234.266 177.83C234.397 177.587 234.57 177.391 234.784 177.242C235.008 177.083 235.26 176.967 235.54 176.892C235.82 176.817 236.11 176.78 236.408 176.78C236.866 176.78 237.309 176.883 237.738 177.088C238.168 177.293 238.49 177.583 238.704 177.956L237.976 178.502Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 184,
    transform: "translate(343.246 19.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1625-inside-9_1593_3270",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.246 19.5H551.246V59.5H343.246V19.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.246 19.5H551.246V59.5H343.246V19.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.246 58.5H343.246V60.5H551.246V58.5Z",
    fill: "#EFEFF0",
    mask: "url(#path-1625-inside-9_1593_3270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.336 42.268H362.516V43.5H355.95V33.588H362.306V34.806H357.336V37.774H362.012V38.964H357.336V42.268ZM365.576 37.956C365.744 37.6013 366.01 37.3027 366.374 37.06C366.748 36.808 367.186 36.682 367.69 36.682C368.138 36.682 368.54 36.7847 368.894 36.99C369.258 37.1953 369.543 37.536 369.748 38.012C369.972 37.5827 370.285 37.256 370.686 37.032C371.088 36.7987 371.526 36.682 372.002 36.682C372.432 36.682 372.8 36.7567 373.108 36.906C373.416 37.046 373.673 37.2373 373.878 37.48C374.084 37.7227 374.233 38.0073 374.326 38.334C374.429 38.6607 374.48 39.0107 374.48 39.384V43.5H373.164V39.818C373.164 39.5473 373.141 39.2907 373.094 39.048C373.048 38.8053 372.968 38.5907 372.856 38.404C372.744 38.2173 372.595 38.068 372.408 37.956C372.222 37.844 371.984 37.788 371.694 37.788C371.396 37.788 371.139 37.8533 370.924 37.984C370.71 38.1053 370.532 38.2687 370.392 38.474C370.262 38.67 370.164 38.894 370.098 39.146C370.042 39.398 370.014 39.6547 370.014 39.916V43.5H368.698V39.552C368.698 39.2907 368.675 39.0527 368.628 38.838C368.582 38.6233 368.502 38.4413 368.39 38.292C368.278 38.1333 368.134 38.012 367.956 37.928C367.779 37.8347 367.56 37.788 367.298 37.788C366.813 37.788 366.407 37.9887 366.08 38.39C365.763 38.782 365.604 39.3093 365.604 39.972V43.5H364.288V38.292C364.288 38.1147 364.284 37.886 364.274 37.606C364.265 37.326 364.251 37.0787 364.232 36.864H365.478C365.497 37.032 365.511 37.2233 365.52 37.438C365.53 37.6433 365.534 37.816 365.534 37.956H365.576ZM378.018 46.86H376.702V36.864H377.99V37.9H378.032C378.247 37.5453 378.56 37.256 378.97 37.032C379.39 36.7987 379.876 36.682 380.426 36.682C380.921 36.682 381.369 36.7707 381.77 36.948C382.181 37.1253 382.531 37.3727 382.82 37.69C383.119 38.0073 383.348 38.3807 383.506 38.81C383.665 39.23 383.744 39.6827 383.744 40.168C383.744 40.6533 383.665 41.1107 383.506 41.54C383.348 41.9693 383.124 42.3427 382.834 42.66C382.545 42.9773 382.195 43.2293 381.784 43.416C381.374 43.5933 380.912 43.682 380.398 43.682C379.922 43.682 379.474 43.5793 379.054 43.374C378.634 43.1687 378.303 42.8793 378.06 42.506H378.018V46.86ZM382.386 40.168C382.386 39.86 382.34 39.5613 382.246 39.272C382.153 38.9827 382.013 38.726 381.826 38.502C381.64 38.278 381.406 38.1007 381.126 37.97C380.856 37.8393 380.538 37.774 380.174 37.774C379.838 37.774 379.53 37.8393 379.25 37.97C378.98 38.1007 378.746 38.278 378.55 38.502C378.354 38.726 378.2 38.9827 378.088 39.272C377.986 39.5613 377.934 39.8647 377.934 40.182C377.934 40.4993 377.986 40.8027 378.088 41.092C378.2 41.3813 378.354 41.638 378.55 41.862C378.746 42.0767 378.98 42.2493 379.25 42.38C379.53 42.5107 379.838 42.576 380.174 42.576C380.538 42.576 380.856 42.5107 381.126 42.38C381.406 42.24 381.64 42.058 381.826 41.834C382.013 41.61 382.153 41.3533 382.246 41.064C382.34 40.7747 382.386 40.476 382.386 40.168ZM386.919 43.5H385.603V32.916H386.919V43.5ZM395.932 40.168C395.932 40.6813 395.839 41.1527 395.652 41.582C395.475 42.0113 395.223 42.3847 394.896 42.702C394.579 43.01 394.201 43.2527 393.762 43.43C393.323 43.598 392.852 43.682 392.348 43.682C391.844 43.682 391.373 43.598 390.934 43.43C390.495 43.2527 390.117 43.01 389.8 42.702C389.483 42.3847 389.231 42.0113 389.044 41.582C388.867 41.1527 388.778 40.6813 388.778 40.168C388.778 39.6547 388.867 39.188 389.044 38.768C389.231 38.3387 389.483 37.97 389.8 37.662C390.117 37.354 390.495 37.116 390.934 36.948C391.373 36.7707 391.844 36.682 392.348 36.682C392.852 36.682 393.323 36.7707 393.762 36.948C394.201 37.116 394.579 37.354 394.896 37.662C395.223 37.97 395.475 38.3387 395.652 38.768C395.839 39.188 395.932 39.6547 395.932 40.168ZM394.56 40.168C394.56 39.8507 394.509 39.5473 394.406 39.258C394.313 38.9687 394.173 38.7167 393.986 38.502C393.799 38.278 393.566 38.1007 393.286 37.97C393.015 37.8393 392.703 37.774 392.348 37.774C391.993 37.774 391.676 37.8393 391.396 37.97C391.125 38.1007 390.897 38.278 390.71 38.502C390.523 38.7167 390.379 38.9687 390.276 39.258C390.183 39.5473 390.136 39.8507 390.136 40.168C390.136 40.4853 390.183 40.7887 390.276 41.078C390.379 41.3673 390.523 41.624 390.71 41.848C390.897 42.072 391.125 42.2493 391.396 42.38C391.676 42.5107 391.993 42.576 392.348 42.576C392.703 42.576 393.015 42.5107 393.286 42.38C393.566 42.2493 393.799 42.072 393.986 41.848C394.173 41.624 394.313 41.3673 394.406 41.078C394.509 40.7887 394.56 40.4853 394.56 40.168ZM400.277 42.072H400.305L402.139 36.864H403.539L400.319 45.068C400.207 45.348 400.086 45.5953 399.955 45.81C399.824 46.034 399.67 46.2207 399.493 46.37C399.316 46.5287 399.106 46.65 398.863 46.734C398.63 46.818 398.35 46.86 398.023 46.86C397.883 46.86 397.738 46.8507 397.589 46.832C397.449 46.8227 397.304 46.7993 397.155 46.762L397.281 45.6C397.505 45.6747 397.724 45.712 397.939 45.712C398.284 45.712 398.541 45.614 398.709 45.418C398.877 45.2313 399.031 44.9607 399.171 44.606L399.591 43.5L396.749 36.864H398.219L400.277 42.072ZM409.67 39.594C409.66 39.3327 409.614 39.09 409.53 38.866C409.455 38.6327 409.338 38.432 409.18 38.264C409.03 38.096 408.839 37.9653 408.606 37.872C408.382 37.7693 408.116 37.718 407.808 37.718C407.528 37.718 407.262 37.7693 407.01 37.872C406.767 37.9653 406.552 38.096 406.366 38.264C406.188 38.432 406.039 38.6327 405.918 38.866C405.806 39.09 405.74 39.3327 405.722 39.594H409.67ZM411 40.126C411 40.2007 411 40.2753 411 40.35C411 40.4247 410.995 40.4993 410.986 40.574H405.722C405.731 40.854 405.792 41.12 405.904 41.372C406.025 41.6147 406.184 41.8293 406.38 42.016C406.576 42.1933 406.8 42.3333 407.052 42.436C407.313 42.5387 407.588 42.59 407.878 42.59C408.326 42.59 408.713 42.492 409.04 42.296C409.366 42.1 409.623 41.862 409.81 41.582L410.734 42.324C410.379 42.7907 409.959 43.136 409.474 43.36C408.998 43.5747 408.466 43.682 407.878 43.682C407.374 43.682 406.907 43.598 406.478 43.43C406.048 43.262 405.68 43.0287 405.372 42.73C405.064 42.422 404.821 42.0533 404.644 41.624C404.466 41.1947 404.378 40.7187 404.378 40.196C404.378 39.6827 404.462 39.2113 404.63 38.782C404.807 38.3433 405.05 37.97 405.358 37.662C405.666 37.354 406.03 37.116 406.45 36.948C406.87 36.7707 407.322 36.682 407.808 36.682C408.293 36.682 408.732 36.7613 409.124 36.92C409.525 37.0787 409.861 37.3073 410.132 37.606C410.412 37.9047 410.626 38.2687 410.776 38.698C410.925 39.118 411 39.594 411 40.126ZM417.695 39.594C417.686 39.3327 417.639 39.09 417.555 38.866C417.48 38.6327 417.364 38.432 417.205 38.264C417.056 38.096 416.864 37.9653 416.631 37.872C416.407 37.7693 416.141 37.718 415.833 37.718C415.553 37.718 415.287 37.7693 415.035 37.872C414.792 37.9653 414.578 38.096 414.391 38.264C414.214 38.432 414.064 38.6327 413.943 38.866C413.831 39.09 413.766 39.3327 413.747 39.594H417.695ZM419.025 40.126C419.025 40.2007 419.025 40.2753 419.025 40.35C419.025 40.4247 419.02 40.4993 419.011 40.574H413.747C413.756 40.854 413.817 41.12 413.929 41.372C414.05 41.6147 414.209 41.8293 414.405 42.016C414.601 42.1933 414.825 42.3333 415.077 42.436C415.338 42.5387 415.614 42.59 415.903 42.59C416.351 42.59 416.738 42.492 417.065 42.296C417.392 42.1 417.648 41.862 417.835 41.582L418.759 42.324C418.404 42.7907 417.984 43.136 417.499 43.36C417.023 43.5747 416.491 43.682 415.903 43.682C415.399 43.682 414.932 43.598 414.503 43.43C414.074 43.262 413.705 43.0287 413.397 42.73C413.089 42.422 412.846 42.0533 412.669 41.624C412.492 41.1947 412.403 40.7187 412.403 40.196C412.403 39.6827 412.487 39.2113 412.655 38.782C412.832 38.3433 413.075 37.97 413.383 37.662C413.691 37.354 414.055 37.116 414.475 36.948C414.895 36.7707 415.348 36.682 415.833 36.682C416.318 36.682 416.757 36.7613 417.149 36.92C417.55 37.0787 417.886 37.3073 418.157 37.606C418.437 37.9047 418.652 38.2687 418.801 38.698C418.95 39.118 419.025 39.594 419.025 40.126ZM425.553 36.864C425.571 37.032 425.585 37.2233 425.595 37.438C425.604 37.6433 425.609 37.816 425.609 37.956H425.651C425.735 37.7787 425.847 37.6153 425.987 37.466C426.136 37.3073 426.304 37.172 426.491 37.06C426.677 36.9387 426.883 36.8453 427.107 36.78C427.331 36.7147 427.564 36.682 427.807 36.682C428.236 36.682 428.605 36.7567 428.913 36.906C429.221 37.046 429.477 37.2373 429.683 37.48C429.888 37.7227 430.037 38.0073 430.131 38.334C430.233 38.6607 430.285 39.0107 430.285 39.384V43.5H428.969V39.818C428.969 39.5473 428.945 39.2907 428.899 39.048C428.861 38.8053 428.787 38.5907 428.675 38.404C428.563 38.2173 428.409 38.068 428.213 37.956C428.017 37.844 427.765 37.788 427.457 37.788C426.934 37.788 426.505 37.9887 426.169 38.39C425.842 38.782 425.679 39.3093 425.679 39.972V43.5H424.363V38.292C424.363 38.1147 424.358 37.886 424.349 37.606C424.339 37.326 424.325 37.0787 424.307 36.864H425.553ZM436.641 39.202C436.641 38.7073 436.492 38.3433 436.193 38.11C435.894 37.8673 435.498 37.746 435.003 37.746C434.63 37.746 434.275 37.8207 433.939 37.97C433.612 38.11 433.337 38.292 433.113 38.516L432.413 37.676C432.74 37.368 433.136 37.1253 433.603 36.948C434.079 36.7707 434.588 36.682 435.129 36.682C435.605 36.682 436.016 36.752 436.361 36.892C436.716 37.0227 437.005 37.2047 437.229 37.438C437.453 37.6713 437.621 37.9467 437.733 38.264C437.845 38.5813 437.901 38.922 437.901 39.286V42.184C437.901 42.408 437.906 42.646 437.915 42.898C437.934 43.1407 437.962 43.3413 437.999 43.5H436.809C436.734 43.1827 436.697 42.8653 436.697 42.548H436.655C436.412 42.9027 436.104 43.178 435.731 43.374C435.367 43.57 434.933 43.668 434.429 43.668C434.168 43.668 433.892 43.6307 433.603 43.556C433.323 43.4907 433.066 43.3787 432.833 43.22C432.6 43.0613 432.404 42.8513 432.245 42.59C432.096 42.3287 432.021 42.0067 432.021 41.624C432.021 41.12 432.156 40.7233 432.427 40.434C432.698 40.1353 433.052 39.9113 433.491 39.762C433.93 39.6033 434.424 39.5007 434.975 39.454C435.526 39.4073 436.081 39.384 436.641 39.384V39.202ZM436.319 40.336C435.992 40.336 435.652 40.35 435.297 40.378C434.952 40.406 434.634 40.462 434.345 40.546C434.065 40.63 433.832 40.756 433.645 40.924C433.458 41.092 433.365 41.316 433.365 41.596C433.365 41.792 433.402 41.9553 433.477 42.086C433.561 42.2167 433.668 42.324 433.799 42.408C433.93 42.492 434.074 42.5527 434.233 42.59C434.392 42.618 434.555 42.632 434.723 42.632C435.339 42.632 435.81 42.45 436.137 42.086C436.473 41.7127 436.641 41.246 436.641 40.686V40.336H436.319ZM441.387 37.956C441.555 37.6013 441.821 37.3027 442.185 37.06C442.558 36.808 442.997 36.682 443.501 36.682C443.949 36.682 444.35 36.7847 444.705 36.99C445.069 37.1953 445.354 37.536 445.559 38.012C445.783 37.5827 446.096 37.256 446.497 37.032C446.898 36.7987 447.337 36.682 447.813 36.682C448.242 36.682 448.611 36.7567 448.919 36.906C449.227 37.046 449.484 37.2373 449.689 37.48C449.894 37.7227 450.044 38.0073 450.137 38.334C450.24 38.6607 450.291 39.0107 450.291 39.384V43.5H448.975V39.818C448.975 39.5473 448.952 39.2907 448.905 39.048C448.858 38.8053 448.779 38.5907 448.667 38.404C448.555 38.2173 448.406 38.068 448.219 37.956C448.032 37.844 447.794 37.788 447.505 37.788C447.206 37.788 446.95 37.8533 446.735 37.984C446.52 38.1053 446.343 38.2687 446.203 38.474C446.072 38.67 445.974 38.894 445.909 39.146C445.853 39.398 445.825 39.6547 445.825 39.916V43.5H444.509V39.552C444.509 39.2907 444.486 39.0527 444.439 38.838C444.392 38.6233 444.313 38.4413 444.201 38.292C444.089 38.1333 443.944 38.012 443.767 37.928C443.59 37.8347 443.37 37.788 443.109 37.788C442.624 37.788 442.218 37.9887 441.891 38.39C441.574 38.782 441.415 39.3093 441.415 39.972V43.5H440.099V38.292C440.099 38.1147 440.094 37.886 440.085 37.606C440.076 37.326 440.062 37.0787 440.043 36.864H441.289C441.308 37.032 441.322 37.2233 441.331 37.438C441.34 37.6433 441.345 37.816 441.345 37.956H441.387ZM457.371 39.594C457.362 39.3327 457.315 39.09 457.231 38.866C457.156 38.6327 457.04 38.432 456.881 38.264C456.732 38.096 456.54 37.9653 456.307 37.872C456.083 37.7693 455.817 37.718 455.509 37.718C455.229 37.718 454.963 37.7693 454.711 37.872C454.468 37.9653 454.254 38.096 454.067 38.264C453.89 38.432 453.74 38.6327 453.619 38.866C453.507 39.09 453.442 39.3327 453.423 39.594H457.371ZM458.701 40.126C458.701 40.2007 458.701 40.2753 458.701 40.35C458.701 40.4247 458.696 40.4993 458.687 40.574H453.423C453.432 40.854 453.493 41.12 453.605 41.372C453.726 41.6147 453.885 41.8293 454.081 42.016C454.277 42.1933 454.501 42.3333 454.753 42.436C455.014 42.5387 455.29 42.59 455.579 42.59C456.027 42.59 456.414 42.492 456.741 42.296C457.068 42.1 457.324 41.862 457.511 41.582L458.435 42.324C458.08 42.7907 457.66 43.136 457.175 43.36C456.699 43.5747 456.167 43.682 455.579 43.682C455.075 43.682 454.608 43.598 454.179 43.43C453.75 43.262 453.381 43.0287 453.073 42.73C452.765 42.422 452.522 42.0533 452.345 41.624C452.168 41.1947 452.079 40.7187 452.079 40.196C452.079 39.6827 452.163 39.2113 452.331 38.782C452.508 38.3433 452.751 37.97 453.059 37.662C453.367 37.354 453.731 37.116 454.151 36.948C454.571 36.7707 455.024 36.682 455.509 36.682C455.994 36.682 456.433 36.7613 456.825 36.92C457.226 37.0787 457.562 37.3073 457.833 37.606C458.113 37.9047 458.328 38.2687 458.477 38.698C458.626 39.118 458.701 39.594 458.701 40.126Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1628-inside-10_1593_3270",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.246 59.5H551.246V107.5H343.246V59.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.246 59.5H551.246V107.5H343.246V59.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.246 106.5H343.246V108.5H551.246V106.5Z",
    fill: "#EFEFF0",
    mask: "url(#path-1628-inside-10_1593_3270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.034 85.484C359.109 85.876 359.281 86.2073 359.552 86.478C359.832 86.7393 360.196 86.87 360.644 86.87C360.989 86.87 361.274 86.8093 361.498 86.688C361.722 86.5573 361.899 86.3847 362.03 86.17C362.17 85.9553 362.263 85.7127 362.31 85.442C362.366 85.162 362.394 84.8727 362.394 84.574V77.588H363.402V84.644C363.402 84.9707 363.365 85.316 363.29 85.68C363.225 86.044 363.094 86.38 362.898 86.688C362.702 86.996 362.431 87.2527 362.086 87.458C361.741 87.654 361.297 87.752 360.756 87.752C360.037 87.752 359.445 87.5653 358.978 87.192C358.511 86.8093 358.217 86.324 358.096 85.736L359.034 85.484ZM370.895 83.72C370.867 83.104 370.666 82.5953 370.293 82.194C369.929 81.7833 369.406 81.578 368.725 81.578C368.407 81.578 368.113 81.6387 367.843 81.76C367.572 81.872 367.334 82.0307 367.129 82.236C366.923 82.432 366.76 82.6607 366.639 82.922C366.517 83.174 366.447 83.44 366.429 83.72H370.895ZM371.861 84.028C371.861 84.0933 371.861 84.1633 371.861 84.238C371.861 84.3127 371.856 84.392 371.847 84.476H366.415C366.424 84.8027 366.489 85.1107 366.611 85.4C366.732 85.6893 366.9 85.9413 367.115 86.156C367.329 86.3707 367.581 86.5433 367.871 86.674C368.16 86.7953 368.473 86.856 368.809 86.856C369.303 86.856 369.728 86.744 370.083 86.52C370.447 86.2867 370.722 86.0207 370.909 85.722L371.623 86.282C371.231 86.7767 370.797 87.1313 370.321 87.346C369.854 87.5607 369.35 87.668 368.809 87.668C368.323 87.668 367.871 87.584 367.451 87.416C367.04 87.2387 366.685 86.996 366.387 86.688C366.088 86.38 365.85 86.016 365.673 85.596C365.505 85.176 365.421 84.7187 365.421 84.224C365.421 83.7293 365.505 83.272 365.673 82.852C365.841 82.432 366.074 82.068 366.373 81.76C366.671 81.452 367.021 81.214 367.423 81.046C367.824 80.8687 368.258 80.78 368.725 80.78C369.238 80.78 369.691 80.8687 370.083 81.046C370.475 81.214 370.801 81.4473 371.063 81.746C371.324 82.0353 371.52 82.376 371.651 82.768C371.791 83.16 371.861 83.58 371.861 84.028ZM377.394 82.502C377.254 82.2313 377.04 82.012 376.75 81.844C376.47 81.6667 376.148 81.578 375.784 81.578C375.616 81.578 375.448 81.5967 375.28 81.634C375.112 81.6713 374.963 81.732 374.832 81.816C374.702 81.9 374.594 82.0073 374.51 82.138C374.436 82.2687 374.398 82.4227 374.398 82.6C374.398 82.908 374.524 83.146 374.776 83.314C375.028 83.4727 375.425 83.608 375.966 83.72C376.741 83.8787 377.31 84.112 377.674 84.42C378.048 84.7187 378.234 85.1247 378.234 85.638C378.234 86.0113 378.16 86.3287 378.01 86.59C377.87 86.842 377.684 87.052 377.45 87.22C377.217 87.3787 376.951 87.4907 376.652 87.556C376.363 87.6307 376.069 87.668 375.77 87.668C375.276 87.668 374.795 87.5653 374.328 87.36C373.862 87.1547 373.479 86.8327 373.18 86.394L373.936 85.834C374.104 86.1233 374.352 86.366 374.678 86.562C375.005 86.758 375.364 86.856 375.756 86.856C375.962 86.856 376.158 86.8373 376.344 86.8C376.531 86.7627 376.694 86.6973 376.834 86.604C376.974 86.5107 377.086 86.394 377.17 86.254C377.254 86.1047 377.296 85.9227 377.296 85.708C377.296 85.3627 377.128 85.106 376.792 84.938C376.466 84.7607 375.99 84.5973 375.364 84.448C375.168 84.4013 374.958 84.3453 374.734 84.28C374.52 84.2053 374.319 84.1027 374.132 83.972C373.946 83.832 373.792 83.6593 373.67 83.454C373.549 83.2487 373.488 82.992 373.488 82.684C373.488 82.348 373.554 82.0633 373.684 81.83C373.815 81.5873 373.988 81.3913 374.202 81.242C374.426 81.0833 374.678 80.9667 374.958 80.892C375.238 80.8173 375.528 80.78 375.826 80.78C376.284 80.78 376.727 80.8827 377.156 81.088C377.586 81.2933 377.908 81.5827 378.122 81.956L377.394 82.502ZM383.615 82.502C383.475 82.2313 383.26 82.012 382.971 81.844C382.691 81.6667 382.369 81.578 382.005 81.578C381.837 81.578 381.669 81.5967 381.501 81.634C381.333 81.6713 381.184 81.732 381.053 81.816C380.922 81.9 380.815 82.0073 380.731 82.138C380.656 82.2687 380.619 82.4227 380.619 82.6C380.619 82.908 380.745 83.146 380.997 83.314C381.249 83.4727 381.646 83.608 382.187 83.72C382.962 83.8787 383.531 84.112 383.895 84.42C384.268 84.7187 384.455 85.1247 384.455 85.638C384.455 86.0113 384.38 86.3287 384.231 86.59C384.091 86.842 383.904 87.052 383.671 87.22C383.438 87.3787 383.172 87.4907 382.873 87.556C382.584 87.6307 382.29 87.668 381.991 87.668C381.496 87.668 381.016 87.5653 380.549 87.36C380.082 87.1547 379.7 86.8327 379.401 86.394L380.157 85.834C380.325 86.1233 380.572 86.366 380.899 86.562C381.226 86.758 381.585 86.856 381.977 86.856C382.182 86.856 382.378 86.8373 382.565 86.8C382.752 86.7627 382.915 86.6973 383.055 86.604C383.195 86.5107 383.307 86.394 383.391 86.254C383.475 86.1047 383.517 85.9227 383.517 85.708C383.517 85.3627 383.349 85.106 383.013 84.938C382.686 84.7607 382.21 84.5973 381.585 84.448C381.389 84.4013 381.179 84.3453 380.955 84.28C380.74 84.2053 380.54 84.1027 380.353 83.972C380.166 83.832 380.012 83.6593 379.891 83.454C379.77 83.2487 379.709 82.992 379.709 82.684C379.709 82.348 379.774 82.0633 379.905 81.83C380.036 81.5873 380.208 81.3913 380.423 81.242C380.647 81.0833 380.899 80.9667 381.179 80.892C381.459 80.8173 381.748 80.78 382.047 80.78C382.504 80.78 382.948 80.8827 383.377 81.088C383.806 81.2933 384.128 81.5827 384.343 81.956L383.615 82.502ZM387.316 87.5H386.364V80.948H387.316V87.5ZM387.512 78.428C387.512 78.624 387.442 78.7873 387.302 78.918C387.162 79.0393 387.008 79.1 386.84 79.1C386.672 79.1 386.518 79.0393 386.378 78.918C386.238 78.7873 386.168 78.624 386.168 78.428C386.168 78.232 386.238 78.0733 386.378 77.952C386.518 77.8213 386.672 77.756 386.84 77.756C387.008 77.756 387.162 77.8213 387.302 77.952C387.442 78.0733 387.512 78.232 387.512 78.428ZM394.568 82.446C394.409 82.194 394.176 81.9887 393.868 81.83C393.569 81.662 393.243 81.578 392.888 81.578C392.505 81.578 392.16 81.648 391.852 81.788C391.544 81.9187 391.278 82.1053 391.054 82.348C390.839 82.5813 390.671 82.8613 390.55 83.188C390.438 83.5053 390.382 83.8507 390.382 84.224C390.382 84.5973 390.438 84.9427 390.55 85.26C390.671 85.5773 390.839 85.8573 391.054 86.1C391.269 86.3333 391.53 86.52 391.838 86.66C392.146 86.7907 392.491 86.856 392.874 86.856C393.294 86.856 393.649 86.7767 393.938 86.618C394.227 86.4593 394.465 86.254 394.652 86.002L395.366 86.534C395.086 86.8793 394.741 87.1547 394.33 87.36C393.929 87.5653 393.443 87.668 392.874 87.668C392.342 87.668 391.861 87.584 391.432 87.416C391.003 87.2387 390.634 86.996 390.326 86.688C390.027 86.38 389.794 86.016 389.626 85.596C389.458 85.176 389.374 84.7187 389.374 84.224C389.374 83.7293 389.458 83.272 389.626 82.852C389.794 82.432 390.027 82.068 390.326 81.76C390.634 81.452 391.003 81.214 391.432 81.046C391.861 80.8687 392.342 80.78 392.874 80.78C393.313 80.78 393.756 80.878 394.204 81.074C394.661 81.2607 395.03 81.5407 395.31 81.914L394.568 82.446ZM400.98 83.272C400.98 82.7027 400.831 82.278 400.532 81.998C400.233 81.718 399.799 81.578 399.23 81.578C398.838 81.578 398.474 81.648 398.138 81.788C397.802 81.928 397.517 82.1147 397.284 82.348L396.752 81.718C397.023 81.4473 397.377 81.2233 397.816 81.046C398.264 80.8687 398.768 80.78 399.328 80.78C399.683 80.78 400.014 80.8313 400.322 80.934C400.63 81.0273 400.901 81.172 401.134 81.368C401.367 81.564 401.549 81.8113 401.68 82.11C401.811 82.4087 401.876 82.7587 401.876 83.16V86.03C401.876 86.282 401.885 86.5433 401.904 86.814C401.923 87.0847 401.951 87.3133 401.988 87.5H401.134C401.106 87.3413 401.083 87.1687 401.064 86.982C401.045 86.7953 401.036 86.6133 401.036 86.436H401.008C400.709 86.8747 400.369 87.192 399.986 87.388C399.613 87.5747 399.16 87.668 398.628 87.668C398.376 87.668 398.115 87.6307 397.844 87.556C397.583 87.4907 397.34 87.3787 397.116 87.22C396.901 87.0613 396.719 86.856 396.57 86.604C396.43 86.352 396.36 86.044 396.36 85.68C396.36 85.176 396.486 84.7793 396.738 84.49C396.999 84.1913 397.345 83.972 397.774 83.832C398.203 83.6827 398.693 83.5893 399.244 83.552C399.804 83.5053 400.383 83.482 400.98 83.482V83.272ZM400.7 84.224C400.308 84.224 399.911 84.2427 399.51 84.28C399.118 84.308 398.759 84.3733 398.432 84.476C398.115 84.5693 397.853 84.7093 397.648 84.896C397.443 85.0827 397.34 85.33 397.34 85.638C397.34 85.8713 397.382 86.0673 397.466 86.226C397.559 86.3847 397.681 86.5153 397.83 86.618C397.979 86.7113 398.143 86.7813 398.32 86.828C398.507 86.8653 398.693 86.884 398.88 86.884C399.216 86.884 399.515 86.828 399.776 86.716C400.037 86.5947 400.257 86.436 400.434 86.24C400.611 86.0347 400.747 85.8013 400.84 85.54C400.933 85.2787 400.98 85.0033 400.98 84.714V84.224H400.7ZM412.686 79.184C412.472 78.8853 412.196 78.6473 411.86 78.47C411.524 78.2833 411.118 78.19 410.642 78.19C410.4 78.19 410.152 78.2273 409.9 78.302C409.648 78.3767 409.42 78.4933 409.214 78.652C409.009 78.8013 408.841 78.9927 408.71 79.226C408.589 79.4593 408.528 79.7347 408.528 80.052C408.528 80.3693 408.589 80.6307 408.71 80.836C408.832 81.0413 408.99 81.2187 409.186 81.368C409.392 81.508 409.62 81.6247 409.872 81.718C410.134 81.8113 410.404 81.9047 410.684 81.998C411.03 82.11 411.375 82.2313 411.72 82.362C412.075 82.4927 412.392 82.6653 412.672 82.88C412.952 83.0853 413.181 83.3513 413.358 83.678C413.536 83.9953 413.624 84.4013 413.624 84.896C413.624 85.3907 413.526 85.82 413.33 86.184C413.144 86.5387 412.896 86.8327 412.588 87.066C412.29 87.2993 411.944 87.472 411.552 87.584C411.17 87.696 410.782 87.752 410.39 87.752C410.092 87.752 409.793 87.7193 409.494 87.654C409.196 87.598 408.911 87.5093 408.64 87.388C408.37 87.2667 408.118 87.1127 407.884 86.926C407.651 86.7393 407.446 86.5247 407.268 86.282L408.136 85.638C408.351 85.9927 408.65 86.2913 409.032 86.534C409.424 86.7673 409.882 86.884 410.404 86.884C410.656 86.884 410.913 86.8467 411.174 86.772C411.436 86.688 411.669 86.5667 411.874 86.408C412.089 86.24 412.262 86.0393 412.392 85.806C412.532 85.5633 412.602 85.2833 412.602 84.966C412.602 84.6207 412.532 84.336 412.392 84.112C412.262 83.8787 412.084 83.6873 411.86 83.538C411.636 83.3793 411.38 83.2487 411.09 83.146C410.801 83.0433 410.498 82.9407 410.18 82.838C409.854 82.7353 409.532 82.6187 409.214 82.488C408.897 82.3573 408.612 82.1893 408.36 81.984C408.108 81.7693 407.903 81.508 407.744 81.2C407.595 80.892 407.52 80.514 407.52 80.066C407.52 79.59 407.614 79.1793 407.8 78.834C407.996 78.4887 408.248 78.204 408.556 77.98C408.864 77.756 409.205 77.5927 409.578 77.49C409.952 77.3873 410.32 77.336 410.684 77.336C411.356 77.336 411.93 77.4573 412.406 77.7C412.882 77.9333 413.242 78.2133 413.484 78.54L412.686 79.184ZM416.669 82.068C416.855 81.6853 417.14 81.3773 417.523 81.144C417.915 80.9013 418.349 80.78 418.825 80.78C419.002 80.78 419.184 80.7987 419.371 80.836C419.567 80.8733 419.753 80.948 419.931 81.06C420.117 81.1627 420.285 81.3027 420.435 81.48C420.593 81.6573 420.729 81.886 420.841 82.166C421.065 81.718 421.368 81.3773 421.751 81.144C422.143 80.9013 422.605 80.78 423.137 80.78C423.967 80.78 424.588 81.0273 424.999 81.522C425.419 82.0167 425.629 82.67 425.629 83.482V87.5H424.677V83.874C424.677 83.1833 424.546 82.628 424.285 82.208C424.033 81.788 423.599 81.578 422.983 81.578C422.637 81.578 422.343 81.648 422.101 81.788C421.867 81.928 421.676 82.1147 421.527 82.348C421.387 82.572 421.284 82.8287 421.219 83.118C421.153 83.4073 421.121 83.706 421.121 84.014V87.5H420.169V83.678C420.169 83.3607 420.145 83.0713 420.099 82.81C420.052 82.5487 419.968 82.3293 419.847 82.152C419.735 81.9653 419.576 81.8253 419.371 81.732C419.165 81.6293 418.904 81.578 418.587 81.578C418.363 81.578 418.134 81.6293 417.901 81.732C417.677 81.8347 417.471 81.9933 417.285 82.208C417.107 82.4133 416.963 82.6793 416.851 83.006C416.739 83.3233 416.683 83.7013 416.683 84.14V87.5H415.731V82.39C415.731 82.2127 415.726 81.984 415.717 81.704C415.707 81.424 415.693 81.172 415.675 80.948H416.585C416.603 81.1253 416.617 81.3213 416.627 81.536C416.636 81.7507 416.641 81.928 416.641 82.068H416.669ZM429.056 87.5H428.104V80.948H429.056V87.5ZM429.252 78.428C429.252 78.624 429.182 78.7873 429.042 78.918C428.902 79.0393 428.748 79.1 428.58 79.1C428.412 79.1 428.258 79.0393 428.118 78.918C427.978 78.7873 427.908 78.624 427.908 78.428C427.908 78.232 427.978 78.0733 428.118 77.952C428.258 77.8213 428.412 77.756 428.58 77.756C428.748 77.756 428.902 77.8213 429.042 77.952C429.182 78.0733 429.252 78.232 429.252 78.428ZM434.544 81.746H432.696V85.568C432.696 85.8107 432.719 86.0113 432.766 86.17C432.813 86.3287 432.878 86.4547 432.962 86.548C433.055 86.632 433.163 86.6927 433.284 86.73C433.405 86.758 433.536 86.772 433.676 86.772C433.807 86.772 433.942 86.7533 434.082 86.716C434.231 86.6787 434.371 86.6273 434.502 86.562L434.544 87.388C434.376 87.4533 434.199 87.5 434.012 87.528C433.835 87.5653 433.639 87.584 433.424 87.584C433.247 87.584 433.06 87.5607 432.864 87.514C432.668 87.4673 432.486 87.3787 432.318 87.248C432.15 87.1173 432.01 86.94 431.898 86.716C431.795 86.492 431.744 86.198 431.744 85.834V81.746H430.386V80.948H431.744V79.1H432.696V80.948H434.544V81.746ZM437.041 82.026C437.219 81.6433 437.513 81.34 437.923 81.116C438.334 80.892 438.773 80.78 439.239 80.78C440.07 80.78 440.691 81.0273 441.101 81.522C441.521 82.0167 441.731 82.67 441.731 83.482V87.5H440.779V83.874C440.779 83.5287 440.751 83.216 440.695 82.936C440.639 82.656 440.541 82.418 440.401 82.222C440.271 82.0167 440.089 81.858 439.855 81.746C439.631 81.634 439.347 81.578 439.001 81.578C438.749 81.578 438.502 81.6293 438.259 81.732C438.026 81.8347 437.816 81.9933 437.629 82.208C437.443 82.4133 437.293 82.6793 437.181 83.006C437.069 83.3233 437.013 83.7013 437.013 84.14V87.5H436.061V76.916H437.013V82.026H437.041Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1631-inside-11_1593_3270",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.246 107.5H551.246V155.5H343.246V107.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.246 107.5H551.246V155.5H343.246V107.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.246 154.5H343.246V156.5H551.246V154.5Z",
    fill: "#EFEFF0",
    mask: "url(#path-1631-inside-11_1593_3270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.034 133.484C359.109 133.876 359.281 134.207 359.552 134.478C359.832 134.739 360.196 134.87 360.644 134.87C360.989 134.87 361.274 134.809 361.498 134.688C361.722 134.557 361.899 134.385 362.03 134.17C362.17 133.955 362.263 133.713 362.31 133.442C362.366 133.162 362.394 132.873 362.394 132.574V125.588H363.402V132.644C363.402 132.971 363.365 133.316 363.29 133.68C363.225 134.044 363.094 134.38 362.898 134.688C362.702 134.996 362.431 135.253 362.086 135.458C361.741 135.654 361.297 135.752 360.756 135.752C360.037 135.752 359.445 135.565 358.978 135.192C358.511 134.809 358.217 134.324 358.096 133.736L359.034 133.484ZM372.407 132.224C372.407 132.719 372.318 133.176 372.141 133.596C371.973 134.016 371.735 134.38 371.427 134.688C371.119 134.996 370.75 135.239 370.321 135.416C369.891 135.584 369.42 135.668 368.907 135.668C368.403 135.668 367.936 135.584 367.507 135.416C367.077 135.239 366.709 134.996 366.401 134.688C366.093 134.38 365.85 134.016 365.673 133.596C365.505 133.176 365.421 132.719 365.421 132.224C365.421 131.729 365.505 131.272 365.673 130.852C365.85 130.432 366.093 130.068 366.401 129.76C366.709 129.452 367.077 129.214 367.507 129.046C367.936 128.869 368.403 128.78 368.907 128.78C369.42 128.78 369.891 128.869 370.321 129.046C370.75 129.214 371.119 129.452 371.427 129.76C371.735 130.068 371.973 130.432 372.141 130.852C372.318 131.272 372.407 131.729 372.407 132.224ZM371.399 132.224C371.399 131.86 371.338 131.519 371.217 131.202C371.105 130.875 370.941 130.595 370.727 130.362C370.512 130.119 370.251 129.928 369.943 129.788C369.635 129.648 369.289 129.578 368.907 129.578C368.524 129.578 368.179 129.648 367.871 129.788C367.572 129.928 367.315 130.119 367.101 130.362C366.886 130.595 366.718 130.875 366.597 131.202C366.485 131.519 366.429 131.86 366.429 132.224C366.429 132.588 366.485 132.933 366.597 133.26C366.718 133.577 366.886 133.857 367.101 134.1C367.315 134.333 367.572 134.52 367.871 134.66C368.179 134.791 368.524 134.856 368.907 134.856C369.289 134.856 369.635 134.791 369.943 134.66C370.251 134.52 370.512 134.333 370.727 134.1C370.941 133.857 371.105 133.577 371.217 133.26C371.338 132.933 371.399 132.588 371.399 132.224ZM375.463 130.026C375.641 129.643 375.935 129.34 376.345 129.116C376.756 128.892 377.195 128.78 377.661 128.78C378.492 128.78 379.113 129.027 379.523 129.522C379.943 130.017 380.153 130.67 380.153 131.482V135.5H379.201V131.874C379.201 131.529 379.173 131.216 379.117 130.936C379.061 130.656 378.963 130.418 378.823 130.222C378.693 130.017 378.511 129.858 378.277 129.746C378.053 129.634 377.769 129.578 377.423 129.578C377.171 129.578 376.924 129.629 376.681 129.732C376.448 129.835 376.238 129.993 376.051 130.208C375.865 130.413 375.715 130.679 375.603 131.006C375.491 131.323 375.435 131.701 375.435 132.14V135.5H374.483V124.916H375.435V130.026H375.463ZM383.471 128.948C383.49 129.125 383.504 129.321 383.513 129.536C383.523 129.751 383.527 129.928 383.527 130.068H383.555C383.742 129.685 384.045 129.377 384.465 129.144C384.885 128.901 385.329 128.78 385.795 128.78C386.626 128.78 387.247 129.027 387.657 129.522C388.077 130.017 388.287 130.67 388.287 131.482V135.5H387.335V131.874C387.335 131.529 387.307 131.216 387.251 130.936C387.195 130.656 387.097 130.418 386.957 130.222C386.827 130.017 386.645 129.858 386.411 129.746C386.187 129.634 385.903 129.578 385.557 129.578C385.305 129.578 385.058 129.629 384.815 129.732C384.582 129.835 384.372 129.993 384.185 130.208C383.999 130.413 383.849 130.679 383.737 131.006C383.625 131.323 383.569 131.701 383.569 132.14V135.5H382.617V130.39C382.617 130.213 382.613 129.984 382.603 129.704C382.594 129.424 382.58 129.172 382.561 128.948H383.471ZM402.652 133.904C402.484 134.156 402.279 134.394 402.036 134.618C401.803 134.842 401.528 135.038 401.21 135.206C400.902 135.374 400.557 135.505 400.174 135.598C399.801 135.701 399.39 135.752 398.942 135.752C398.196 135.752 397.505 135.621 396.87 135.36C396.236 135.099 395.69 134.739 395.232 134.282C394.775 133.815 394.416 133.265 394.154 132.63C393.902 131.995 393.776 131.3 393.776 130.544C393.776 129.788 393.907 129.093 394.168 128.458C394.43 127.823 394.789 127.277 395.246 126.82C395.713 126.353 396.259 125.989 396.884 125.728C397.519 125.467 398.205 125.336 398.942 125.336C399.306 125.336 399.661 125.373 400.006 125.448C400.361 125.523 400.692 125.63 401 125.77C401.308 125.901 401.588 126.064 401.84 126.26C402.092 126.447 402.302 126.661 402.47 126.904L401.63 127.52C401.528 127.361 401.388 127.203 401.21 127.044C401.042 126.885 400.842 126.745 400.608 126.624C400.375 126.503 400.118 126.405 399.838 126.33C399.568 126.255 399.274 126.218 398.956 126.218C398.312 126.218 397.734 126.335 397.22 126.568C396.716 126.801 396.287 127.119 395.932 127.52C395.578 127.912 395.307 128.369 395.12 128.892C394.934 129.415 394.84 129.965 394.84 130.544C394.84 131.123 394.934 131.673 395.12 132.196C395.316 132.719 395.592 133.181 395.946 133.582C396.301 133.974 396.73 134.287 397.234 134.52C397.748 134.753 398.322 134.87 398.956 134.87C399.526 134.87 400.067 134.753 400.58 134.52C401.094 134.287 401.523 133.913 401.868 133.4L402.652 133.904ZM408.212 131.272C408.212 130.703 408.063 130.278 407.764 129.998C407.466 129.718 407.032 129.578 406.462 129.578C406.07 129.578 405.706 129.648 405.37 129.788C405.034 129.928 404.75 130.115 404.516 130.348L403.984 129.718C404.255 129.447 404.61 129.223 405.048 129.046C405.496 128.869 406 128.78 406.56 128.78C406.915 128.78 407.246 128.831 407.554 128.934C407.862 129.027 408.133 129.172 408.366 129.368C408.6 129.564 408.782 129.811 408.912 130.11C409.043 130.409 409.108 130.759 409.108 131.16V134.03C409.108 134.282 409.118 134.543 409.136 134.814C409.155 135.085 409.183 135.313 409.22 135.5H408.366C408.338 135.341 408.315 135.169 408.296 134.982C408.278 134.795 408.268 134.613 408.268 134.436H408.24C407.942 134.875 407.601 135.192 407.218 135.388C406.845 135.575 406.392 135.668 405.86 135.668C405.608 135.668 405.347 135.631 405.076 135.556C404.815 135.491 404.572 135.379 404.348 135.22C404.134 135.061 403.952 134.856 403.802 134.604C403.662 134.352 403.592 134.044 403.592 133.68C403.592 133.176 403.718 132.779 403.97 132.49C404.232 132.191 404.577 131.972 405.006 131.832C405.436 131.683 405.926 131.589 406.476 131.552C407.036 131.505 407.615 131.482 408.212 131.482V131.272ZM407.932 132.224C407.54 132.224 407.144 132.243 406.742 132.28C406.35 132.308 405.991 132.373 405.664 132.476C405.347 132.569 405.086 132.709 404.88 132.896C404.675 133.083 404.572 133.33 404.572 133.638C404.572 133.871 404.614 134.067 404.698 134.226C404.792 134.385 404.913 134.515 405.062 134.618C405.212 134.711 405.375 134.781 405.552 134.828C405.739 134.865 405.926 134.884 406.112 134.884C406.448 134.884 406.747 134.828 407.008 134.716C407.27 134.595 407.489 134.436 407.666 134.24C407.844 134.035 407.979 133.801 408.072 133.54C408.166 133.279 408.212 133.003 408.212 132.714V132.224H407.932ZM415.915 129.62L411.995 134.674H416.055V135.5H410.735V134.828L414.641 129.746H410.931V128.948H415.915V129.62ZM421.884 131.272C421.884 130.703 421.735 130.278 421.436 129.998C421.137 129.718 420.703 129.578 420.134 129.578C419.742 129.578 419.378 129.648 419.042 129.788C418.706 129.928 418.421 130.115 418.188 130.348L417.656 129.718C417.927 129.447 418.281 129.223 418.72 129.046C419.168 128.869 419.672 128.78 420.232 128.78C420.587 128.78 420.918 128.831 421.226 128.934C421.534 129.027 421.805 129.172 422.038 129.368C422.271 129.564 422.453 129.811 422.584 130.11C422.715 130.409 422.78 130.759 422.78 131.16V134.03C422.78 134.282 422.789 134.543 422.808 134.814C422.827 135.085 422.855 135.313 422.892 135.5H422.038C422.01 135.341 421.987 135.169 421.968 134.982C421.949 134.795 421.94 134.613 421.94 134.436H421.912C421.613 134.875 421.273 135.192 420.89 135.388C420.517 135.575 420.064 135.668 419.532 135.668C419.28 135.668 419.019 135.631 418.748 135.556C418.487 135.491 418.244 135.379 418.02 135.22C417.805 135.061 417.623 134.856 417.474 134.604C417.334 134.352 417.264 134.044 417.264 133.68C417.264 133.176 417.39 132.779 417.642 132.49C417.903 132.191 418.249 131.972 418.678 131.832C419.107 131.683 419.597 131.589 420.148 131.552C420.708 131.505 421.287 131.482 421.884 131.482V131.272ZM421.604 132.224C421.212 132.224 420.815 132.243 420.414 132.28C420.022 132.308 419.663 132.373 419.336 132.476C419.019 132.569 418.757 132.709 418.552 132.896C418.347 133.083 418.244 133.33 418.244 133.638C418.244 133.871 418.286 134.067 418.37 134.226C418.463 134.385 418.585 134.515 418.734 134.618C418.883 134.711 419.047 134.781 419.224 134.828C419.411 134.865 419.597 134.884 419.784 134.884C420.12 134.884 420.419 134.828 420.68 134.716C420.941 134.595 421.161 134.436 421.338 134.24C421.515 134.035 421.651 133.801 421.744 133.54C421.837 133.279 421.884 133.003 421.884 132.714V132.224H421.604ZM430.623 134.394C430.343 134.814 429.979 135.131 429.531 135.346C429.083 135.561 428.621 135.668 428.145 135.668C427.631 135.668 427.165 135.579 426.745 135.402C426.334 135.225 425.979 134.982 425.681 134.674C425.391 134.366 425.163 134.002 424.995 133.582C424.836 133.162 424.757 132.709 424.757 132.224C424.757 131.739 424.836 131.286 424.995 130.866C425.163 130.446 425.391 130.082 425.681 129.774C425.979 129.466 426.334 129.223 426.745 129.046C427.165 128.869 427.631 128.78 428.145 128.78C428.621 128.78 429.083 128.892 429.531 129.116C429.979 129.331 430.343 129.653 430.623 130.082H430.651V124.916H431.603V135.5H430.651V134.394H430.623ZM425.765 132.224C425.765 132.588 425.821 132.933 425.933 133.26C426.045 133.577 426.203 133.857 426.409 134.1C426.623 134.333 426.885 134.52 427.193 134.66C427.501 134.791 427.851 134.856 428.243 134.856C428.607 134.856 428.943 134.791 429.251 134.66C429.559 134.52 429.825 134.333 430.049 134.1C430.273 133.867 430.445 133.591 430.567 133.274C430.697 132.947 430.763 132.597 430.763 132.224C430.763 131.851 430.697 131.505 430.567 131.188C430.445 130.861 430.273 130.581 430.049 130.348C429.825 130.105 429.559 129.919 429.251 129.788C428.943 129.648 428.607 129.578 428.243 129.578C427.851 129.578 427.501 129.648 427.193 129.788C426.885 129.928 426.623 130.119 426.409 130.362C426.203 130.595 426.045 130.875 425.933 131.202C425.821 131.519 425.765 131.86 425.765 132.224ZM440.657 132.224C440.657 132.719 440.568 133.176 440.391 133.596C440.223 134.016 439.985 134.38 439.677 134.688C439.369 134.996 439 135.239 438.571 135.416C438.141 135.584 437.67 135.668 437.157 135.668C436.653 135.668 436.186 135.584 435.757 135.416C435.327 135.239 434.959 134.996 434.651 134.688C434.343 134.38 434.1 134.016 433.923 133.596C433.755 133.176 433.671 132.719 433.671 132.224C433.671 131.729 433.755 131.272 433.923 130.852C434.1 130.432 434.343 130.068 434.651 129.76C434.959 129.452 435.327 129.214 435.757 129.046C436.186 128.869 436.653 128.78 437.157 128.78C437.67 128.78 438.141 128.869 438.571 129.046C439 129.214 439.369 129.452 439.677 129.76C439.985 130.068 440.223 130.432 440.391 130.852C440.568 131.272 440.657 131.729 440.657 132.224ZM439.649 132.224C439.649 131.86 439.588 131.519 439.467 131.202C439.355 130.875 439.191 130.595 438.977 130.362C438.762 130.119 438.501 129.928 438.193 129.788C437.885 129.648 437.539 129.578 437.157 129.578C436.774 129.578 436.429 129.648 436.121 129.788C435.822 129.928 435.565 130.119 435.351 130.362C435.136 130.595 434.968 130.875 434.847 131.202C434.735 131.519 434.679 131.86 434.679 132.224C434.679 132.588 434.735 132.933 434.847 133.26C434.968 133.577 435.136 133.857 435.351 134.1C435.565 134.333 435.822 134.52 436.121 134.66C436.429 134.791 436.774 134.856 437.157 134.856C437.539 134.856 437.885 134.791 438.193 134.66C438.501 134.52 438.762 134.333 438.977 134.1C439.191 133.857 439.355 133.577 439.467 133.26C439.588 132.933 439.649 132.588 439.649 132.224ZM442.705 130.39C442.705 130.213 442.701 129.984 442.691 129.704C442.682 129.424 442.668 129.172 442.649 128.948H443.559C443.578 129.125 443.592 129.321 443.601 129.536C443.611 129.751 443.615 129.928 443.615 130.068H443.643C443.83 129.685 444.11 129.377 444.483 129.144C444.857 128.901 445.277 128.78 445.743 128.78C445.865 128.78 445.972 128.785 446.065 128.794C446.168 128.803 446.271 128.822 446.373 128.85L446.247 129.746C446.191 129.727 446.098 129.709 445.967 129.69C445.837 129.671 445.706 129.662 445.575 129.662C445.323 129.662 445.081 129.709 444.847 129.802C444.614 129.895 444.409 130.045 444.231 130.25C444.063 130.446 443.923 130.703 443.811 131.02C443.709 131.328 443.657 131.701 443.657 132.14V135.5H442.705V130.39ZM454.014 132.224C454.014 132.719 453.925 133.176 453.748 133.596C453.58 134.016 453.342 134.38 453.034 134.688C452.726 134.996 452.357 135.239 451.928 135.416C451.499 135.584 451.027 135.668 450.514 135.668C450.01 135.668 449.543 135.584 449.114 135.416C448.685 135.239 448.316 134.996 448.008 134.688C447.7 134.38 447.457 134.016 447.28 133.596C447.112 133.176 447.028 132.719 447.028 132.224C447.028 131.729 447.112 131.272 447.28 130.852C447.457 130.432 447.7 130.068 448.008 129.76C448.316 129.452 448.685 129.214 449.114 129.046C449.543 128.869 450.01 128.78 450.514 128.78C451.027 128.78 451.499 128.869 451.928 129.046C452.357 129.214 452.726 129.452 453.034 129.76C453.342 130.068 453.58 130.432 453.748 130.852C453.925 131.272 454.014 131.729 454.014 132.224ZM453.006 132.224C453.006 131.86 452.945 131.519 452.824 131.202C452.712 130.875 452.549 130.595 452.334 130.362C452.119 130.119 451.858 129.928 451.55 129.788C451.242 129.648 450.897 129.578 450.514 129.578C450.131 129.578 449.786 129.648 449.478 129.788C449.179 129.928 448.923 130.119 448.708 130.362C448.493 130.595 448.325 130.875 448.204 131.202C448.092 131.519 448.036 131.86 448.036 132.224C448.036 132.588 448.092 132.933 448.204 133.26C448.325 133.577 448.493 133.857 448.708 134.1C448.923 134.333 449.179 134.52 449.478 134.66C449.786 134.791 450.131 134.856 450.514 134.856C450.897 134.856 451.242 134.791 451.55 134.66C451.858 134.52 452.119 134.333 452.334 134.1C452.549 133.857 452.712 133.577 452.824 133.26C452.945 132.933 453.006 132.588 453.006 132.224Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1634-inside-12_1593_3270",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.246 155.5H551.246V203.5H343.246V155.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.246 155.5H551.246V203.5H343.246V155.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.246 202.5H343.246V204.5H551.246V202.5Z",
    fill: "#EFEFF0",
    mask: "url(#path-1634-inside-12_1593_3270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.864 175.184C363.649 174.885 363.374 174.647 363.038 174.47C362.702 174.283 362.296 174.19 361.82 174.19C361.577 174.19 361.33 174.227 361.078 174.302C360.826 174.377 360.597 174.493 360.392 174.652C360.187 174.801 360.019 174.993 359.888 175.226C359.767 175.459 359.706 175.735 359.706 176.052C359.706 176.369 359.767 176.631 359.888 176.836C360.009 177.041 360.168 177.219 360.364 177.368C360.569 177.508 360.798 177.625 361.05 177.718C361.311 177.811 361.582 177.905 361.862 177.998C362.207 178.11 362.553 178.231 362.898 178.362C363.253 178.493 363.57 178.665 363.85 178.88C364.13 179.085 364.359 179.351 364.536 179.678C364.713 179.995 364.802 180.401 364.802 180.896C364.802 181.391 364.704 181.82 364.508 182.184C364.321 182.539 364.074 182.833 363.766 183.066C363.467 183.299 363.122 183.472 362.73 183.584C362.347 183.696 361.96 183.752 361.568 183.752C361.269 183.752 360.971 183.719 360.672 183.654C360.373 183.598 360.089 183.509 359.818 183.388C359.547 183.267 359.295 183.113 359.062 182.926C358.829 182.739 358.623 182.525 358.446 182.282L359.314 181.638C359.529 181.993 359.827 182.291 360.21 182.534C360.602 182.767 361.059 182.884 361.582 182.884C361.834 182.884 362.091 182.847 362.352 182.772C362.613 182.688 362.847 182.567 363.052 182.408C363.267 182.24 363.439 182.039 363.57 181.806C363.71 181.563 363.78 181.283 363.78 180.966C363.78 180.621 363.71 180.336 363.57 180.112C363.439 179.879 363.262 179.687 363.038 179.538C362.814 179.379 362.557 179.249 362.268 179.146C361.979 179.043 361.675 178.941 361.358 178.838C361.031 178.735 360.709 178.619 360.392 178.488C360.075 178.357 359.79 178.189 359.538 177.984C359.286 177.769 359.081 177.508 358.922 177.2C358.773 176.892 358.698 176.514 358.698 176.066C358.698 175.59 358.791 175.179 358.978 174.834C359.174 174.489 359.426 174.204 359.734 173.98C360.042 173.756 360.383 173.593 360.756 173.49C361.129 173.387 361.498 173.336 361.862 173.336C362.534 173.336 363.108 173.457 363.584 173.7C364.06 173.933 364.419 174.213 364.662 174.54L363.864 175.184ZM371.668 183.5C371.65 183.323 371.636 183.127 371.626 182.912C371.617 182.697 371.612 182.52 371.612 182.38H371.584C371.398 182.763 371.094 183.075 370.674 183.318C370.254 183.551 369.811 183.668 369.344 183.668C368.514 183.668 367.888 183.421 367.468 182.926C367.058 182.431 366.852 181.778 366.852 180.966V176.948H367.804V180.574C367.804 180.919 367.832 181.232 367.888 181.512C367.944 181.792 368.038 182.035 368.168 182.24C368.308 182.436 368.49 182.59 368.714 182.702C368.948 182.814 369.237 182.87 369.582 182.87C369.834 182.87 370.077 182.819 370.31 182.716C370.553 182.613 370.768 182.459 370.954 182.254C371.141 182.039 371.29 181.773 371.402 181.456C371.514 181.129 371.57 180.747 371.57 180.308V176.948H372.522V182.058C372.522 182.235 372.527 182.464 372.536 182.744C372.546 183.024 372.56 183.276 372.578 183.5H371.668ZM375.043 178.39C375.043 178.213 375.039 177.984 375.029 177.704C375.02 177.424 375.006 177.172 374.987 176.948H375.897C375.916 177.125 375.93 177.321 375.939 177.536C375.949 177.751 375.953 177.928 375.953 178.068H375.981C376.168 177.685 376.448 177.377 376.821 177.144C377.195 176.901 377.615 176.78 378.081 176.78C378.203 176.78 378.31 176.785 378.403 176.794C378.506 176.803 378.609 176.822 378.711 176.85L378.585 177.746C378.529 177.727 378.436 177.709 378.305 177.69C378.175 177.671 378.044 177.662 377.913 177.662C377.661 177.662 377.419 177.709 377.185 177.802C376.952 177.895 376.747 178.045 376.569 178.25C376.401 178.446 376.261 178.703 376.149 179.02C376.047 179.328 375.995 179.701 375.995 180.14V183.5H375.043V178.39ZM381.054 183.5H380.102V176.948H381.054V183.5ZM381.25 174.428C381.25 174.624 381.18 174.787 381.04 174.918C380.9 175.039 380.746 175.1 380.578 175.1C380.41 175.1 380.256 175.039 380.116 174.918C379.976 174.787 379.906 174.624 379.906 174.428C379.906 174.232 379.976 174.073 380.116 173.952C380.256 173.821 380.41 173.756 380.578 173.756C380.746 173.756 380.9 173.821 381.04 173.952C381.18 174.073 381.25 174.232 381.25 174.428ZM385.842 182.478H385.87L387.9 176.948H388.936L385.674 185.194C385.478 185.698 385.226 186.099 384.918 186.398C384.619 186.706 384.185 186.86 383.616 186.86C383.327 186.86 383.042 186.832 382.762 186.776L382.86 185.908C383.084 185.983 383.317 186.02 383.56 186.02C383.887 186.02 384.143 185.917 384.33 185.712C384.517 185.516 384.68 185.231 384.82 184.858L385.352 183.486L382.552 176.948H383.616L385.842 182.478ZM394.554 179.272C394.554 178.703 394.405 178.278 394.106 177.998C393.807 177.718 393.373 177.578 392.804 177.578C392.412 177.578 392.048 177.648 391.712 177.788C391.376 177.928 391.091 178.115 390.858 178.348L390.326 177.718C390.597 177.447 390.951 177.223 391.39 177.046C391.838 176.869 392.342 176.78 392.902 176.78C393.257 176.78 393.588 176.831 393.896 176.934C394.204 177.027 394.475 177.172 394.708 177.368C394.941 177.564 395.123 177.811 395.254 178.11C395.385 178.409 395.45 178.759 395.45 179.16V182.03C395.45 182.282 395.459 182.543 395.478 182.814C395.497 183.085 395.525 183.313 395.562 183.5H394.708C394.68 183.341 394.657 183.169 394.638 182.982C394.619 182.795 394.61 182.613 394.61 182.436H394.582C394.283 182.875 393.943 183.192 393.56 183.388C393.187 183.575 392.734 183.668 392.202 183.668C391.95 183.668 391.689 183.631 391.418 183.556C391.157 183.491 390.914 183.379 390.69 183.22C390.475 183.061 390.293 182.856 390.144 182.604C390.004 182.352 389.934 182.044 389.934 181.68C389.934 181.176 390.06 180.779 390.312 180.49C390.573 180.191 390.919 179.972 391.348 179.832C391.777 179.683 392.267 179.589 392.818 179.552C393.378 179.505 393.957 179.482 394.554 179.482V179.272ZM394.274 180.224C393.882 180.224 393.485 180.243 393.084 180.28C392.692 180.308 392.333 180.373 392.006 180.476C391.689 180.569 391.427 180.709 391.222 180.896C391.017 181.083 390.914 181.33 390.914 181.638C390.914 181.871 390.956 182.067 391.04 182.226C391.133 182.385 391.255 182.515 391.404 182.618C391.553 182.711 391.717 182.781 391.894 182.828C392.081 182.865 392.267 182.884 392.454 182.884C392.79 182.884 393.089 182.828 393.35 182.716C393.611 182.595 393.831 182.436 394.008 182.24C394.185 182.035 394.321 181.801 394.414 181.54C394.507 181.279 394.554 181.003 394.554 180.714V180.224H394.274ZM406.261 175.184C406.046 174.885 405.771 174.647 405.435 174.47C405.099 174.283 404.693 174.19 404.217 174.19C403.974 174.19 403.727 174.227 403.475 174.302C403.223 174.377 402.994 174.493 402.789 174.652C402.583 174.801 402.415 174.993 402.285 175.226C402.163 175.459 402.103 175.735 402.103 176.052C402.103 176.369 402.163 176.631 402.285 176.836C402.406 177.041 402.565 177.219 402.761 177.368C402.966 177.508 403.195 177.625 403.447 177.718C403.708 177.811 403.979 177.905 404.259 177.998C404.604 178.11 404.949 178.231 405.295 178.362C405.649 178.493 405.967 178.665 406.247 178.88C406.527 179.085 406.755 179.351 406.933 179.678C407.11 179.995 407.199 180.401 407.199 180.896C407.199 181.391 407.101 181.82 406.905 182.184C406.718 182.539 406.471 182.833 406.163 183.066C405.864 183.299 405.519 183.472 405.127 183.584C404.744 183.696 404.357 183.752 403.965 183.752C403.666 183.752 403.367 183.719 403.069 183.654C402.77 183.598 402.485 183.509 402.215 183.388C401.944 183.267 401.692 183.113 401.459 182.926C401.225 182.739 401.02 182.525 400.843 182.282L401.711 181.638C401.925 181.993 402.224 182.291 402.607 182.534C402.999 182.767 403.456 182.884 403.979 182.884C404.231 182.884 404.487 182.847 404.749 182.772C405.01 182.688 405.243 182.567 405.449 182.408C405.663 182.24 405.836 182.039 405.967 181.806C406.107 181.563 406.177 181.283 406.177 180.966C406.177 180.621 406.107 180.336 405.967 180.112C405.836 179.879 405.659 179.687 405.435 179.538C405.211 179.379 404.954 179.249 404.665 179.146C404.375 179.043 404.072 178.941 403.755 178.838C403.428 178.735 403.106 178.619 402.789 178.488C402.471 178.357 402.187 178.189 401.935 177.984C401.683 177.769 401.477 177.508 401.319 177.2C401.169 176.892 401.095 176.514 401.095 176.066C401.095 175.59 401.188 175.179 401.375 174.834C401.571 174.489 401.823 174.204 402.131 173.98C402.439 173.756 402.779 173.593 403.153 173.49C403.526 173.387 403.895 173.336 404.259 173.336C404.931 173.336 405.505 173.457 405.981 173.7C406.457 173.933 406.816 174.213 407.059 174.54L406.261 175.184ZM410.313 178.026C410.49 177.643 410.784 177.34 411.195 177.116C411.606 176.892 412.044 176.78 412.511 176.78C413.342 176.78 413.962 177.027 414.373 177.522C414.793 178.017 415.003 178.67 415.003 179.482V183.5H414.051V179.874C414.051 179.529 414.023 179.216 413.967 178.936C413.911 178.656 413.813 178.418 413.673 178.222C413.542 178.017 413.36 177.858 413.127 177.746C412.903 177.634 412.618 177.578 412.273 177.578C412.021 177.578 411.774 177.629 411.531 177.732C411.298 177.835 411.088 177.993 410.901 178.208C410.714 178.413 410.565 178.679 410.453 179.006C410.341 179.323 410.285 179.701 410.285 180.14V183.5H409.333V172.916H410.285V178.026H410.313ZM421.597 179.272C421.597 178.703 421.448 178.278 421.149 177.998C420.85 177.718 420.416 177.578 419.847 177.578C419.455 177.578 419.091 177.648 418.755 177.788C418.419 177.928 418.134 178.115 417.901 178.348L417.369 177.718C417.64 177.447 417.994 177.223 418.433 177.046C418.881 176.869 419.385 176.78 419.945 176.78C420.3 176.78 420.631 176.831 420.939 176.934C421.247 177.027 421.518 177.172 421.751 177.368C421.984 177.564 422.166 177.811 422.297 178.11C422.428 178.409 422.493 178.759 422.493 179.16V182.03C422.493 182.282 422.502 182.543 422.521 182.814C422.54 183.085 422.568 183.313 422.605 183.5H421.751C421.723 183.341 421.7 183.169 421.681 182.982C421.662 182.795 421.653 182.613 421.653 182.436H421.625C421.326 182.875 420.986 183.192 420.603 183.388C420.23 183.575 419.777 183.668 419.245 183.668C418.993 183.668 418.732 183.631 418.461 183.556C418.2 183.491 417.957 183.379 417.733 183.22C417.518 183.061 417.336 182.856 417.187 182.604C417.047 182.352 416.977 182.044 416.977 181.68C416.977 181.176 417.103 180.779 417.355 180.49C417.616 180.191 417.962 179.972 418.391 179.832C418.82 179.683 419.31 179.589 419.861 179.552C420.421 179.505 421 179.482 421.597 179.482V179.272ZM421.317 180.224C420.925 180.224 420.528 180.243 420.127 180.28C419.735 180.308 419.376 180.373 419.049 180.476C418.732 180.569 418.47 180.709 418.265 180.896C418.06 181.083 417.957 181.33 417.957 181.638C417.957 181.871 417.999 182.067 418.083 182.226C418.176 182.385 418.298 182.515 418.447 182.618C418.596 182.711 418.76 182.781 418.937 182.828C419.124 182.865 419.31 182.884 419.497 182.884C419.833 182.884 420.132 182.828 420.393 182.716C420.654 182.595 420.874 182.436 421.051 182.24C421.228 182.035 421.364 181.801 421.457 181.54C421.55 181.279 421.597 181.003 421.597 180.714V180.224H421.317ZM424.946 178.39C424.946 178.213 424.941 177.984 424.932 177.704C424.922 177.424 424.908 177.172 424.89 176.948H425.8C425.818 177.125 425.832 177.321 425.842 177.536C425.851 177.751 425.856 177.928 425.856 178.068H425.884C426.07 177.685 426.35 177.377 426.724 177.144C427.097 176.901 427.517 176.78 427.984 176.78C428.105 176.78 428.212 176.785 428.306 176.794C428.408 176.803 428.511 176.822 428.614 176.85L428.488 177.746C428.432 177.727 428.338 177.709 428.208 177.69C428.077 177.671 427.946 177.662 427.816 177.662C427.564 177.662 427.321 177.709 427.088 177.802C426.854 177.895 426.649 178.045 426.472 178.25C426.304 178.446 426.164 178.703 426.052 179.02C425.949 179.328 425.898 179.701 425.898 180.14V183.5H424.946V178.39ZM430.928 178.068C431.115 177.685 431.4 177.377 431.782 177.144C432.174 176.901 432.608 176.78 433.084 176.78C433.262 176.78 433.444 176.799 433.63 176.836C433.826 176.873 434.013 176.948 434.19 177.06C434.377 177.163 434.545 177.303 434.694 177.48C434.853 177.657 434.988 177.886 435.1 178.166C435.324 177.718 435.628 177.377 436.01 177.144C436.402 176.901 436.864 176.78 437.396 176.78C438.227 176.78 438.848 177.027 439.258 177.522C439.678 178.017 439.888 178.67 439.888 179.482V183.5H438.936V179.874C438.936 179.183 438.806 178.628 438.544 178.208C438.292 177.788 437.858 177.578 437.242 177.578C436.897 177.578 436.603 177.648 436.36 177.788C436.127 177.928 435.936 178.115 435.786 178.348C435.646 178.572 435.544 178.829 435.478 179.118C435.413 179.407 435.38 179.706 435.38 180.014V183.5H434.428V179.678C434.428 179.361 434.405 179.071 434.358 178.81C434.312 178.549 434.228 178.329 434.106 178.152C433.994 177.965 433.836 177.825 433.63 177.732C433.425 177.629 433.164 177.578 432.846 177.578C432.622 177.578 432.394 177.629 432.16 177.732C431.936 177.835 431.731 177.993 431.544 178.208C431.367 178.413 431.222 178.679 431.11 179.006C430.998 179.323 430.942 179.701 430.942 180.14V183.5H429.99V178.39C429.99 178.213 429.986 177.984 429.976 177.704C429.967 177.424 429.953 177.172 429.934 176.948H430.844C430.863 177.125 430.877 177.321 430.886 177.536C430.896 177.751 430.9 177.928 430.9 178.068H430.928ZM446.48 179.272C446.48 178.703 446.331 178.278 446.032 177.998C445.733 177.718 445.299 177.578 444.73 177.578C444.338 177.578 443.974 177.648 443.638 177.788C443.302 177.928 443.017 178.115 442.784 178.348L442.252 177.718C442.523 177.447 442.877 177.223 443.316 177.046C443.764 176.869 444.268 176.78 444.828 176.78C445.183 176.78 445.514 176.831 445.822 176.934C446.13 177.027 446.401 177.172 446.634 177.368C446.867 177.564 447.049 177.811 447.18 178.11C447.311 178.409 447.376 178.759 447.376 179.16V182.03C447.376 182.282 447.385 182.543 447.404 182.814C447.423 183.085 447.451 183.313 447.488 183.5H446.634C446.606 183.341 446.583 183.169 446.564 182.982C446.545 182.795 446.536 182.613 446.536 182.436H446.508C446.209 182.875 445.869 183.192 445.486 183.388C445.113 183.575 444.66 183.668 444.128 183.668C443.876 183.668 443.615 183.631 443.344 183.556C443.083 183.491 442.84 183.379 442.616 183.22C442.401 183.061 442.219 182.856 442.07 182.604C441.93 182.352 441.86 182.044 441.86 181.68C441.86 181.176 441.986 180.779 442.238 180.49C442.499 180.191 442.845 179.972 443.274 179.832C443.703 179.683 444.193 179.589 444.744 179.552C445.304 179.505 445.883 179.482 446.48 179.482V179.272ZM446.2 180.224C445.808 180.224 445.411 180.243 445.01 180.28C444.618 180.308 444.259 180.373 443.932 180.476C443.615 180.569 443.353 180.709 443.148 180.896C442.943 181.083 442.84 181.33 442.84 181.638C442.84 181.871 442.882 182.067 442.966 182.226C443.059 182.385 443.181 182.515 443.33 182.618C443.479 182.711 443.643 182.781 443.82 182.828C444.007 182.865 444.193 182.884 444.38 182.884C444.716 182.884 445.015 182.828 445.276 182.716C445.537 182.595 445.757 182.436 445.934 182.24C446.111 182.035 446.247 181.801 446.34 181.54C446.433 181.279 446.48 181.003 446.48 180.714V180.224H446.2Z",
    fill: "#333333"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1593_3270",
    x: 61.2461,
    y: 13.5,
    width: 499,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.704167 0 0 0 0 0.704167 0 0 0 0 0.704167 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1593_3270"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.716667 0 0 0 0 0.716667 0 0 0 0 0.716667 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1593_3270",
    result: "effect2_dropShadow_1593_3270"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1593_3270",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.2461,
    width: 581,
    height: 223,
    rx: 111.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2422)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 9.16553)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 18.333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 27.498)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 36.6641)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 45.8296)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 54.9961)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 64.1616)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 73.3267)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 82.4941)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 91.6587)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 100.825)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 109.991)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 119.157)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 128.323)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 137.489)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 146.655)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 155.822)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 164.986)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 174.151)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 183.318)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 192.483)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 201.649)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 210.816)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.058,
    height: 9.16586,
    fill: "white",
    transform: "translate(18.2432 219.98)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.2461,
    y: 19.5,
    width: 483,
    height: 184,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27_1593_3270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 484,
    height: 184,
    fill: "white",
    transform: "translate(67.2461 19.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagsBanner);
export default __webpack_public_path__ + "static/media/flags-banner.dcea3277f573482c02ca66f847b14130.svg";
export { ForwardRef as ReactComponent };